webpackJsonp([4],{

/***/ "/eR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createInputsModel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__programs_inputs_inputCollection__ = __webpack_require__("n67P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__programs_inputs_videoInput__ = __webpack_require__("p2DF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__programs_inputs_imageInput__ = __webpack_require__("I6d+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appState_js__ = __webpack_require__("NEgR");





// Allows to bind media elements to vector field
function createInputsModel(ctx) {
  ctx.inputs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__programs_inputs_inputCollection__["a" /* default */])();
  var inputs = [];
  readInputsFromAppState();

  var api = {
    getInputs: getInputs,
    addInput: addInput
  };

  return api;

  function getInputs() {
    return inputs;
  }

  function addInput(inputNumber) {
    var vm = createInputElementViewModel(ctx, inputNumber);
    inputs.push(vm);
    return vm;
  }

  function readInputsFromAppState() {
    var i0 = __WEBPACK_IMPORTED_MODULE_3__appState_js__["a" /* default */].getQS().get('i0');
    if (i0) {
      var vm = addInput(0);
      vm.link = i0;
      vm.updateBinding( /* immediate = */true);
    }
  }
}

function createInputElementViewModel(ctx, inputNumber) {
  var pendingUpdate = null;

  var input = {
    link: '',
    error: null,
    name: 'input' + inputNumber,
    updateBinding: updateBinding
  };

  return input;

  function updateBinding(immediate) {
    if (pendingUpdate) {
      clearTimeout(pendingUpdate);
      pendingUpdate = null;
    }

    if (immediate) {
      setBinding();
    } else {
      pendingUpdate = setTimeout(setBinding, 300);
    }
  }

  function setBinding() {
    input.error = null;
    pendingUpdate = null;
    var binding = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__programs_inputs_imageInput__["a" /* default */])(ctx, input.link, {
      done: function done() {
        // TODO: Preview
        __WEBPACK_IMPORTED_MODULE_3__appState_js__["a" /* default */].getQS().set('i' + inputNumber, input.link);
      },
      error: function error(err) {
        // TODO: Better Error checking
        input.error = err;
      }
    });
    ctx.inputs.bindInput(0, binding);
  }
}

/***/ }),

/***/ "3xg8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updatePositionProgram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gl_utils__ = __webpack_require__("Ddjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shaderGraph_updatePositionGraph__ = __webpack_require__("Qv35");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colorModes__ = __webpack_require__("6c6E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colorProgram__ = __webpack_require__("gIFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_textureCollection__ = __webpack_require__("pXNl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_makeStatCounter__ = __webpack_require__("V39N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_floatPacking__ = __webpack_require__("FaU1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bus__ = __webpack_require__("eBcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__bus__);









var particlePositionShaderCodeBuilder = new __WEBPACK_IMPORTED_MODULE_1__shaderGraph_updatePositionGraph__["a" /* default */]();

function updatePositionProgram(ctx) {
  var gl = ctx.gl;
  var readTextures, writeTextures;
  var particleStateResolution;
  var updateProgram;
  var readVelocity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__colorProgram__["a" /* default */])(ctx);

  // If someone needs to get vectors out from the GPU, they send a `vector-lines-request`
  // over the bus. This request is delayed until next compute frame. Once it is handled,
  // we send them back response with calculated vectors.
  var pendingVectorLines;

  // TODO: need to make sure we are not leaking.
  __WEBPACK_IMPORTED_MODULE_7__bus___default.a.on('vector-lines-request', putVectorLinesRequestIntoQueue);

  return {
    updateCode: updateCode,
    updateParticlesPositions: updateParticlesPositions,
    updateParticlesCount: updateParticlesCount,
    prepareToDraw: prepareToDraw
  };

  function updateCode(vectorField) {
    particlePositionShaderCodeBuilder.setCustomVectorField(vectorField);
    var fragment = particlePositionShaderCodeBuilder.getFragmentShader();
    var vertex = particlePositionShaderCodeBuilder.getVertexShader();

    var newProgram = __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].createProgram(gl, vertex, fragment);

    if (updateProgram) updateProgram.unload();
    updateProgram = newProgram;

    if (ctx.colorMode === __WEBPACK_IMPORTED_MODULE_2__colorModes__["a" /* default */].VELOCITY) readVelocity.requestSpeedUpdate();
  }

  function updateParticlesCount(x, y) {
    particleStateResolution = ctx.particleStateResolution;

    var dimensions = [{
      name: 'x',
      particleState: x
    }, {
      name: 'y',
      particleState: y
    }];

    if (readTextures) readTextures.dispose();
    readTextures = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_textureCollection__["a" /* default */])(gl, dimensions, particleStateResolution);

    if (writeTextures) writeTextures.dispose();
    writeTextures = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_textureCollection__["a" /* default */])(gl, dimensions, particleStateResolution);

    readVelocity.updateParticlesCount();
  }

  function prepareToDraw(program) {
    var colorMode = ctx.colorMode;
    if (colorMode === __WEBPACK_IMPORTED_MODULE_2__colorModes__["a" /* default */].VELOCITY) readVelocity.setColorMinMax(program);

    readTextures.bindTextures(gl, program);
  }

  function updateParticlesPositions() {
    var program = updateProgram;
    gl.useProgram(program.program);

    __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindAttribute(gl, ctx.quadBuffer, program.a_pos, 2);

    ctx.inputs.updateBindings(program);

    // TODO: Remove this.
    if (ctx.audioTexture) {
      __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindTexture(gl, ctx.audioTexture, 5);
      gl.uniform1i(program['u_audio'], 5);
    }

    readTextures.bindTextures(gl, program);

    gl.uniform1f(program.u_rand_seed, ctx.frameSeed);
    gl.uniform1f(program.u_h, ctx.integrationTimeStep);
    gl.uniform1f(program.frame, ctx.frame);
    var cursor = ctx.cursor;
    gl.uniform4f(program.cursor, cursor.clickX, cursor.clickY, cursor.hoverX, cursor.hoverY);

    var bbox = ctx.bbox;
    gl.uniform2f(program.u_min, bbox.minX, bbox.minY);
    gl.uniform2f(program.u_max, bbox.maxX, bbox.maxY);

    gl.uniform1f(program.u_drop_rate, ctx.dropProbability);

    // Draw each coordinate individually
    for (var i = 0; i < writeTextures.length; ++i) {
      var writeInfo = writeTextures.get(i);
      gl.uniform1i(program.u_out_coordinate, i);
      __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindFramebuffer(gl, ctx.framebuffer, writeInfo.texture);
      gl.viewport(0, 0, particleStateResolution, particleStateResolution);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
    }

    // TODO: I think I need to keep this time-bound, i.e. allocate X ms to
    // process particle positions, and move on. So that the rendering thread is not paused for too long
    if (ctx.colorMode === __WEBPACK_IMPORTED_MODULE_2__colorModes__["a" /* default */].VELOCITY) {
      readVelocity.updateParticlesPositions(program);
    }

    if (pendingVectorLines) {
      processVectorLinesRequest(program);
      pendingVectorLines = null;
    }

    // swap the particle state textures so the new one becomes the current one
    var temp = readTextures;
    readTextures = writeTextures;
    writeTextures = temp;
  }

  function putVectorLinesRequestIntoQueue(request) {
    pendingVectorLines = request;
  }

  function processVectorLinesRequest(program) {
    // TODO: Move this out
    var dimensions = [{
      name: 'x',
      particleState: pendingVectorLines.x
    }, {
      name: 'y',
      particleState: pendingVectorLines.y
    }];

    // We create temporary textures and load requested positions in there
    var resolutionOfParticlesInRequest = pendingVectorLines.resolution;
    var numParticles = resolutionOfParticlesInRequest * resolutionOfParticlesInRequest;

    var texturesForRead = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_textureCollection__["a" /* default */])(gl, dimensions, resolutionOfParticlesInRequest);
    var texturesForWrite = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_textureCollection__["a" /* default */])(gl, dimensions, resolutionOfParticlesInRequest);

    texturesForRead.bindTextures(gl, program);

    // Then we request coordinates out from GPU for each dimension
    var writeInfo = texturesForWrite.get(0);
    gl.uniform1i(program.u_out_coordinate, 6); // v_x

    __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindFramebuffer(gl, ctx.framebuffer, writeInfo.texture);
    gl.viewport(0, 0, resolutionOfParticlesInRequest, resolutionOfParticlesInRequest);
    gl.drawArrays(gl.TRIANGLES, 0, 6);

    var velocity_x = new Uint8Array(numParticles * 4);
    gl.readPixels(0, 0, resolutionOfParticlesInRequest, resolutionOfParticlesInRequest, gl.RGBA, gl.UNSIGNED_BYTE, velocity_x);

    gl.uniform1i(program.u_out_coordinate, 7); // v_y
    writeInfo = texturesForWrite.get(1);
    __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindFramebuffer(gl, ctx.framebuffer, writeInfo.texture);
    gl.viewport(0, 0, resolutionOfParticlesInRequest, resolutionOfParticlesInRequest);
    gl.drawArrays(gl.TRIANGLES, 0, 6);

    var velocity_y = new Uint8Array(numParticles * 4);
    gl.readPixels(0, 0, resolutionOfParticlesInRequest, resolutionOfParticlesInRequest, gl.RGBA, gl.UNSIGNED_BYTE, velocity_y);

    texturesForWrite.dispose();
    texturesForRead.dispose();

    var xStats = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_makeStatCounter__["a" /* default */])();
    var yStats = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_makeStatCounter__["a" /* default */])();

    var decoded_velocity_x = new Float32Array(numParticles);
    var decoded_velocity_y = new Float32Array(numParticles);
    for (var i = 0; i < velocity_y.length; i += 4) {
      var idx = i / 4;
      var vx = readFloat(velocity_x, i);
      var vy = readFloat(velocity_y, i);
      decoded_velocity_x[idx] = vx;
      decoded_velocity_y[idx] = vy;
      xStats.add(vx);
      yStats.add(vy);
    }

    var vectorLineInfo = {
      xStats: xStats,
      yStats: yStats,
      decoded_velocity_x: decoded_velocity_x,
      decoded_velocity_y: decoded_velocity_y,
      resolution: resolutionOfParticlesInRequest
    };

    __WEBPACK_IMPORTED_MODULE_7__bus___default.a.fire('vector-line-ready', vectorLineInfo);
  }
}

function readFloat(buffer, offset) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_floatPacking__["b" /* decodeFloatRGBA */])(buffer[offset + 0], buffer[offset + 1], buffer[offset + 2], buffer[offset + 3]);
}

/***/ }),

/***/ "4KA4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var BaseShaderNode = function () {
  function BaseShaderNode() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BaseShaderNode);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BaseShaderNode, [{
    key: 'getDefines',
    value: function getDefines() {
      return '';
    }
  }, {
    key: 'getFunctions',
    value: function getFunctions() {
      return '';
    }
  }, {
    key: 'getMainBody',
    value: function getMainBody() {
      return '';
    }
  }]);

  return BaseShaderNode;
}();

/* harmony default export */ __webpack_exports__["a"] = (BaseShaderNode);

/***/ }),

/***/ "6c6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Various color modes.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Each particle gets its own color
   */
  UNIFORM: 1,

  /**
   * Color of a particle depends on its velocity
   */
  VELOCITY: 2,

  /**
   * Color of a particle depends on its velocity vector angle.
   */
  ANGLE: 3,

  /**
   * The color comes from a shader. WIP
   */
  CUSTOM: 4
});

/***/ }),

/***/ "7QEO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  "name": "Secret door",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": -0.15344999999999986,
  "cy": -0.1291,
  "w": 7.4611,
  "h": 7.4611,
  "code": "// p.x and p.y are current coordinates\n  // v.x and v.y is a velocity at point p\n  vec2 get_velocity(vec2 p) {\n    vec2 v = vec2(0., 0.);\n\n    // change this to get a new vector field\n    v.x = p.y*p.y ;\n    v.y = -p.x*p.x *.05;\n\n    return v;\n  }"
}, {
  "name": "Miserables graph with edges",
  "timeStep": -0.001,
  "fadeOut": 0.998,
  "dropProbability": 0.008,
  "colorMode": 2,
  "cx": 0.467,
  "cy": 1.5294,
  "w": 0.9368,
  "h": 0.9368,
  "showBindings": 1,
  "i0": "https://gist.githubusercontent.com/anvaka/ebc18e3ffe05b0709a7ae933261fa2e9/raw/bafb63d01e0ab37c1f9b51522a5ec4fbc19bc4f1/edges.png",
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  vec4 c = texture2D(input0, vec2(mod(p.x,1.), 1. - mod(p.y, 1.)));\n  v.x = (c.r + c.g/255.) - 0.5;\n  v.y = 0.5 - (c.b + c.a/255.);\n\n  if (length(v) < 0.1) v = vec2(0.);\n  return (v);\n}",
  "particleCount": 40000
}, {
  "name": "Roads",
  "timeStep": 0.001,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 2,
  "cx": 0.478,
  "cy": 0.2636,
  "w": 0.9922,
  "h": 0.9922,
  "showBindings": 0,
  "i0": "https://gist.githubusercontent.com/anvaka/ebc18e3ffe05b0709a7ae933261fa2e9/raw/cd7d82c5a235f50f5655ac94aa9077709731adde/binary_tree.png",
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  vec4 c = texture2D(input0, vec2(mod(p.x,1.), 1. - mod(p.y, 1.)));\n  v.x = (c.r + c.g/255.) - 0.5;\n  v.y = 0.5 - (c.b + c.a/255.);\n\n  return (v);\n}",
  "particleCount": 40000
}, {
  "name": "Four counterclockwise cogs pushing particles clockwise :)",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": 0.7887499999999994,
  "cy": -0.5769500000000001,
  "w": 16.3759,
  "h": 16.3759,
  "code": "vec2 field(vec2 p) {\n  float d = length(p);\n  return vec2(-p.y, p.x) * exp(-d*d*0.1);\n}\n// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  v = field(p + vec2(-5., 0.)) +\n    field(p + vec2(-2.5, 2.5)) +\n    field(p + vec2(0., 0.)) +\n    field(p + vec2(-2.5, -2.5));\n  return v;\n}"
}, {
  "name": "Waveshaping [interactive]",
  "cx": 0,
  "cy": -0.060899999999999954,
  "w": 12,
  "h": 12,
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 2,
  "code": "float f(float x) {\n  bool supportsHover = length(cursor.zw) > 0.01;\n  vec2 c = supportsHover ? cursor.zw : cursor.xy;\n  float f1 = sin(x);\n  float f2 = sin(2.*x);\n  float f3 = sin(3.*x);\n  float f4 = sin(4.*x);\n  float f5 = sin(5.*x);\n  return f1 +\n    f2*c.x/4. +\n    f3*c.y/6. +\n    f4*c.x/8. +\n    f5*c.y/10.;\n}\n\nfloat df(float x) {\n  float h = 0.001;\n  return (f(x+h)-f(x-h))/(2.*h);\n}\n\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  float fx = f(p.x);\n  float d = abs(p.y-fx);\n  float dfx = df(p.x);\n  vec2 toOrigin = -p/(20.*length(p));\n  vec2 toF = 0.1*vec2(0.,fx-p.y);\n  v = d < 0.1 ? vec2(1.,dfx) : toF;\n  return v;\n}",
  "particleCount": 50000
}, {
  "name": "Hex plane [interactive]",
  "timeStep": 0.01,
  "fadeOut": 0.99,
  "dropProbability": 0.99,
  "colorMode": 3,
  "cx": 0,
  "cy": 0,
  "w": 8.5398,
  "h": 8.5398,
  "code": "vec2 nearest(vec2 p) {\n// Charles Chambers black hex magic\nfloat temp = floor(p.x + sqrt(3.) * p.y + 1.);\nfloat q = floor((floor(2.*p.x+1.) + temp) / 3.);\nfloat r = floor((temp + floor(-p.x + sqrt(3.) * p.y + 1.))/3.);\nreturn vec2(q-p.y/2.,r-p.y/8.);\n}\n\n// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n  float f = frame/1000.;\n  float z = (3.-p.y)/(6.+cursor.zw.y*2.);\n  float a = cursor.zw.x;\n  vec2 r = vec2(cos(a)*p.x - sin(a)*p.y,sin(a)*p.x+cos(a)*p.y);\n  vec2 t = vec2(r.x / z, r.y / z);\n  vec2 n = nearest(t);\n  v.x = t.x-n.x;\n  v.y = t.y-n.y;\n  return v;\n}",
  "particleCount": 500000
}, {
  "name": "Rain",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": 0,
  "cy": 0,
  "w": 8.5398,
  "h": 8.5398,
  "code": "bool isUnshadowed(vec2 p) {\n  bool upper = length(p) > 1.0 && p.y > 0.0;\n  bool lower = length(p) > 1.0 && p.y < 0.0 && abs(p.x) > 1.0;\n  return upper || lower;\n}\n\nvec2 unshadowedV(vec2 p) {\n  return vec2(0.0,-3.0+p.y);\n}\n\nbool isSpray(vec2 p) {\n  return length(p) > 1.0 && abs(p.x) < 1.0;\n}\n\nvec2 sprayV(vec2 p) {\n  float vy = -1.0+p.y;\n  float vx = p.x > 0.0 ? (1.0-p.x)/vy : (-1.0-p.x)/vy;\n  return vec2(vx,vy);\n}\n\nbool isCircle(vec2 p) {\n  return length(p) > 1.0 && length(p) < 1.05;\n}\n\nvec2 circleV(vec2 p) {\n  vec2 v = vec2(0., 0.);\n  v.x = sign(p.x)* p.y;\n  v.y = -abs(p.x);\n  return v;\n}\n\n// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  v = isCircle(p) ? circleV(p) :\n      isUnshadowed(p) ? unshadowedV(p) :\n      isSpray(p) ? sprayV(p) : vec2(1.0/0.0,1.0/0.0);\n\n  return v;\n}",
  "particleCount": 10000
}, {
  "name": "Mouse-driven Julia Set",
  "timeStep": 0.01,
  "fadeOut": 0.9,
  "dropProbability": 0.009,
  "colorMode": 3,
  "cx": -0.27144999999999997,
  "cy": 0.14175000000000004,
  "w": 6.120699999999999,
  "h": 6.120699999999999,
  "particleCount": 1000000,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float a = cursor.zw.x;\nfloat b = cursor.zw.y;\nfloat sx = p.x/2.0;\nfloat sy = p.y/2.0;\nfloat i1x = sx*sx - sy*sy+a;\nfloat i1y = -2.0*sx*sy+b;\nfloat i2x = i1x*i1x - i1y*i1y+a;\nfloat i2y = -2.0*i1x*i1y+b;\nfloat i3x = i2x*i2x - i2y*i2y+a;\nfloat i3y = -2.0*i2x*i2y+b;\nfloat i4x = i3x*i3x - i3y*i3y+a;\nfloat i4y = -2.0*i3x*i3y+b;\nfloat i5x = i4x*i4x - i4y*i4y+a;\nfloat i5y = -2.0*i4x*i4y+b;\nfloat i6x = i5x*i5x - i5y*i5y+a;\nfloat i6y = -2.0*i5x*i5y+b;\nfloat i7x = i6x*i6x - i6y*i6y+a;\nfloat i7y = -2.0*i6x*i6y+b;\nfloat i8x = i7x*i7x - i7y*i7y+a;\nfloat i8y = -2.0*i7x*i7y+b;\nfloat i9x = i8x*i8x - i8y*i8y+a;\nfloat i9y = -2.0*i8x*i8y+b;\n\n  float n = sqrt(i9x*i9x+i9y*i9y);\n\nv.x = n > 2.0 ? -p.x/10.0 : p.x/10.0;\nv.y = n > 2.0 ? -p.y/10.0 : p.y/10.0;\n\n  return v;\n}"
}, {
  "name": "Hyperjump",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 2,
  "cx": 0.523299999999999,
  "cy": 1.2703999999999995,
  "w": 48.3842,
  "h": 48.3842,
  "code": "vec2 circle(vec2 p, vec2 c) {\n  vec2 c0 = p - c;\n  vec2 p0 = vec2(-c0.y, c0.x);\n  float l = length(p0);\n  return p0 * exp(-l*sin(frame*0.01));\n}\n// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = circle(p, vec2(0., 0.));\n\n  float r = 7.;\n  for (int i = 0; i < 2; ++i) {\n    float a = 0.01 * frame + float(i) * 2.*PI/7.;\n    v += circle(p, vec2(r * cos(a) , r * sin(a)));\n  }\n  return v;\n}",
  "particleCount": 30000
}, {
  "name": "Particle Grinder",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": 0.028149999999999675,
  "cy": 0.08830000000000005,
  "w": 9.045300000000001,
  "h": 9.045300000000001,
  "code": "vec2 tensor(vec2 p, vec2 c0, vec4 abcd, float N) {\n  vec2 p0 = p - c0;\n  float theta = atan(p0.y, p0.x);\n  float c = cos(N * theta);\n  float s = sin(N * theta);\n  return length(p0) * vec2(abcd[2] * c + abcd[3] * s,\n              abcd[0] * c + abcd[1] * s);\n}\n\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n  v = tensor(p, vec2(0., 0.), vec4(-2., 0., 0., 1.), 2.);\n  return v;\n}"
}, {
  "name": "Hyperbolic flux [interactive]",
  "timeStep": 0.001,
  "fadeOut": 0.999,
  "dropProbability": 0.009,
  "colorMode": 3,
  "cx": -0.11990000000000034,
  "cy": 0.018899999999999917,
  "w": 8.5442,
  "h": 8.5442,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  float ax = (cursor.zw.x - p.x);\n  float ay = (cursor.zw.y - p.y);\n  float al = sqrt(ax*ax+ay*ay);\n\n  float rx = (p.x-cursor.xy.x);\n  float ry = (p.y-cursor.xy.y);\n  float rl = sqrt(rx*rx+ry*ry);\n\n  // change this to get a new vector field\n  v.x = (ax*ax*ry + ay*rx*rx)/(al*rl);\n  v.y = (ay*ay*rx + ax*ry*ry)/(al*rl);\n\n  return v;\n}",
  "particleCount": 1000000
}, {
  "name": "Swim against the current",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 3,
  "cx": 3.0524500000000003,
  "cy": -1.3792,
  "w": 8.5397,
  "h": 8.5397,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float dx1 = cursor.zw.x - p.x;\nfloat dy1 = cursor.zw.y - p.y;\nfloat dl1 = sqrt(dx1*dx1+dy1*dy1);\ndx1 = dx1/dl1;\ndy1 = dy1/dl1;\n\nfloat dx2 = cursor.xy.x - p.x;\nfloat dy2 = cursor.xy.y - p.y;\nfloat dl2 = sqrt(dx2*dx2+dy2*dy2);\ndx2 = dx2/dl2;\ndy2 = dy2/dl2;\n\nfloat fx = cursor.xy.x - cursor.zw.x;\nfloat fy = cursor.xy.y -\ncursor.zw.y;\nfloat fl = sqrt(fx*fx+fy*fy);\nfx = -fx/fl;\nfy = -fy/fl;\n\nfloat d1 = (dx1*fx + dy1*fy)/(dl1*fl);\nfloat d2 = 1.-d1;\nv.x = d1*fx+d2*dx2;\nv.y = d1*fy+d2*dy2;\n\n  return v;\n}",
  "particleCount": 100900
}, {
  "name": "Eye of Sauron (interactive)",
  "timeStep": 0.01,
  "fadeOut": 0.988,
  "dropProbability": 0.008,
  "colorMode": 2,
  "cx": 0.3991000000000007,
  "cy": -0.11315000000000008,
  "w": 37.0984,
  "h": 37.0984,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  // calculate distortion map (reverse solver)\n// the distortion map is based on a sphere, but smoothed to the ends: sqrt(1-(x^8/(x^8-1))^(1/4))\n\nfloat dist_radius = 7.8;\nvec2 distortion = cursor.zw;\nif (length(distortion) > 4.5) {\n    distortion = normalize(distortion) *4.5;\n}\n\n// iterative reverse algo. after all, we knew the result position already, we're trying to reason back to what the original position was\nvec2 d = p;\nfor (int i = 0; i < 10; i++) {\n    // calculate distortion effect magnitude\n    float d_scale = pow(length(d) / dist_radius, 8.);\n    // pseudo sphere map\n    d_scale = pow(1. - pow(d_scale / (d_scale + 1.), .25), .5);\n    d = p - distortion * d_scale;\n}\n\n// calculate differentials, working backwards (i.e. what change in p would result from a change in d)\nvec2 d_dx  = d + vec2(0.1, 0.0);\nfloat d_dx_scale = pow(length(d_dx) / dist_radius, 8.);\nd_dx_scale = pow(1. - pow(d_dx_scale / (d_dx_scale + 1.), .25), .5);\nvec2 dx = (d_dx + distortion * d_dx_scale - p) / 0.1;\n\nvec2 d_dy  = d + vec2(0.0, 0.1);\nfloat d_dy_scale = pow(length(d_dy) / dist_radius, 8.);\nd_dy_scale = pow(1. - pow(d_dy_scale / (d_dy_scale + 1.), .25), .5);\nvec2 dy = (d_dy + distortion * d_dy_scale - p) / 0.1;\n\n// center parts\nfloat pupilrange = length(vec2(d.y, d.x + 6.*sign(d.x)));\nvec2 pupilborder = 2.6*vec2(-d.y, (d.x + 6.*sign(d.x)) );\nv += pupilborder * smoothstep(6.6, 6.8, pupilrange) * (1. - smoothstep(6.9, 7.1, pupilrange));\n\nfloat range = length(d);\nvec2 iris = 7.*d/sqrt(range);\nv += iris * smoothstep(7.0, 7.5, pupilrange) * (1. - smoothstep(3.8, 4.0, range));\n\nvec2 pupil = 1.*vec2(d.x+1.*sign(d.x), d.y);\nv += pupil * (1. - smoothstep(6.6, 6.8, pupilrange));\n\n// absolute parts\nvec2 psign = sign(d);\nvec2 a = abs(d);\nvec2 vabs = vec2(0.0, 0.0);\n\nfloat borderrange = length(vec2(d.x, d.y + 7.*sign(d.y)));\nvec2 border = -1.5*vec2(a.y + 7.*sign(a.y) - 3./(a.y + 1.), -a.x + 3./(a.x + 1.));\nvabs += border * smoothstep(10.8, 11.25, borderrange) * (1. - smoothstep(11.25, 11.7, borderrange)) * smoothstep(3.8, 4.1, range) * (a.y / (a.y + 1.));\n\nvec2 irisborder = 5.*vec2(a.y, -a.x) * (a.y / (a.y + 3.))+ .2 * a;\nvabs += irisborder * smoothstep(3.8, 4.25, range) * (1. - smoothstep(4.25, 4.7, range));\n\nvec2 white = 12.*vec2(1.0, -0.2 * (a.y));\nvabs += white * smoothstep(4.3, 4.5, range) * (1. - smoothstep(11., 11.3, borderrange));\n\nv += vabs * psign;\n\n// outside part\nvec2 outside = d / pow(borderrange - 10., 2.);\nv -= outside * smoothstep(11.3, 11.5, borderrange);\n\n// velocity distortion mapping\nv = v.x * dx + v.y * dy;\n\n// color mapping\nif (length(v) > 0.01) {\n    v = normalize(v) * 10.;\n}\nv = v / (1. + 0.1 * (borderrange - 10.) * smoothstep(11.5, 12.5, borderrange));\n\n\n\n  return v;\n}",
  "particleCount": 30000
}, {
  "name": "Combination of two fields. One follows cursor",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": 0,
  "cy": 0,
  "w": 8.5398,
  "h": 8.5398,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  vec2 p1 = p - vec2(-2., 0.);\nvec2 p2 = p - cursor.zw;\n\nfloat l1 = length(p1), l2 = length(p2);\n\nv = vec2(-p1.y, p1.x)/(l1 * l1) + vec2(-p2.y, p2.x)/(l2 * l2);\n\n  return v;\n}"
}, {
  "name": "[Randomized] nice symmetry",
  "timeStep": 0.01,
  "fadeOut": 0.988,
  "dropProbability": 0.008,
  "colorMode": 2,
  "cx": -2.6390499999999992,
  "cy": -1.1419499999999996,
  "w": 46.508700000000005,
  "h": 46.508700000000005,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  v.x = p.y/cos(length(p));\n  v.y = max((log(p.y)+p.x),p.x);\n\n  return v;\n}",
  "particleCount": 20000
}, {
  "name": "A city block from a parallel Universe (by @MananG_8)",
  "timeStep": 0.01,
  "fadeOut": 0.988,
  "dropProbability": 0.008,
  "colorMode": 1,
  "cx": 0.6165500000000002,
  "cy": -1.87745,
  "w": 9.0455,
  "h": 9.0455,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  v.x = sin(tan(p.x))*cos(tan(p.y));\n  v.y = sin(tan(p.y))*cos(tan(p.x));\n\n  return v;\n}\n",
  "particleCount": 20000
}, {
  "name": "♥ by @SAKrisT",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 2,
  "cx": -1.4246499999999997,
  "cy": 0.92285,
  "w": 8.5397,
  "h": 8.5397,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float size = 1.0;\n  vec2 o = (p)/(1.6* size);\n  float a = o.x*o.x+o.y*o.y-0.3;\n  v = vec2(step(a*a*a, o.x*o.x*o.y*o.y*o.y));\n\n  return v;\n}\n"
}, {
  "name": "Dynamic vector field by Evgeniy Andreev. Not defined by physical system, but beautiful.",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 3,
  "cx": -1.6564499999999995,
  "cy": -0.36424999999999974,
  "w": 24.7317,
  "h": 24.7317,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float dt = 0.01;\n  float t = frame*dt;\n  float w = 2.*PI/5.;\n  float A = 2.;\n\n  float d = sqrt(p.x*p.x + p.y*p.y);\n  v.x = A*cos(w*t/d);\n  v.y = A*sin(w*t/d);\n\n  return v;\n}",
  "particleCount": 3000
}, {
  "name": "Behold (by /u/censored_username)",
  "timeStep": 0.01,
  "fadeOut": 0.988,
  "dropProbability": 0.008,
  "colorMode": 2,
  "cx": 0.12704999999999966,
  "cy": 0.1923499999999998,
  "w": 22.5709,
  "h": 22.5709,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float x = abs(p.x) - 5.;\n  float side = sign(p.x);\n  float range = length(vec2(x, p.y));\n  float irisrange = length(vec2(x, p.y + 2.*sign(p.y)));\n\n  vec2 border = 1.*vec2(p.y + 2.2*sign(p.y) * (p.y*p.y / (p.y*p.y + 0.01)), -x);\n\n  vec2 outside = vec2(x / (1.+10./abs(p.x*p.x)), p.y);\n\n  vec2 spiral = vec2(p.y, -x);\n\n  vec2 iris = sin(-range * 10.) * spiral + 0.05*vec2(x, p.y);\n\n  v += outside * (smoothstep(4.0, 4.5, irisrange)/range*5. - 5.*smoothstep(0.9, 0.7, range)/range);\n  v += border * smoothstep(3.5, 4., irisrange) * smoothstep(4.5, 4., irisrange);\n  v += iris * smoothstep(2.0, 1.5, range) * smoothstep(0.8, 1., range);\n  v -= 10.0*spiral * smoothstep(1.0, 0.8, range) * smoothstep(0.7, 0.9, range);\n\n  v.x *= side;\n  v *= -1.;\n\n  return v;\n}",
  "particleCount": 30000
}, {
  "name": "README 1",
  "timeStep": 0.007,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": -1.275949999999999,
  "cy": -1.6277,
  "w": 30.2937,
  "h": 30.2937,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  v.x = length(p)*min(sin(p.y),cos(p.x));\nv.y = cos((p.y+p.y));\n\n\n  return v;\n}"
}, {
  "name": "README 2",
  "timeStep": 0.007,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": -1.275949999999999,
  "cy": -1.62765,
  "w": 30.2937,
  "h": 30.2937,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  v.x = cos(p.y);\nv.y = cos(p.x);\n\n\n  return v;\n}"
}, {
  "name": "README 3",
  "timeStep": 0.02,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": 0.21419999999999995,
  "cy": -0.7710999999999997,
  "w": 55.970200000000006,
  "h": 55.970200000000006,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  v.x = min(sin(exp(p.x)),sin(length(p)));\nv.y = sin(p.x);\n\n\n  return v;\n}"
}, {
  "name": "README 4",
  "timeStep": 0.02,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": 2.43185,
  "cy": -1.1695,
  "w": 11.4385,
  "h": 11.4385,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  v.x = (p.y+cos(p.y));\nv.y = sin(min(length(p),log((p.y+p.x))*p.x));\n\n\n  return v;\n}"
}, {
  "name": "True Dipole",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": 0,
  "cy": 0,
  "w": 8.5398,
  "h": 8.5398,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float x = p.x;\nfloat y = p.y;\n\n// true dipole\nv.x = 2.0*x*y;\nv.y = y*y - x*x;\n\n  return v;\n}"
}, {
  "name": "Flow profile of a sphere",
  "timeStep": 0.011,
  "fadeOut": 0.99999,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": -0.7177000000000002,
  "cy": -0.11769999999999992,
  "w": 11.434999999999999,
  "h": 11.434999999999999,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float x = p.x;\nfloat y = p.y;\nfloat r = sqrt(x*x+y*y);\nfloat sinth = y/r;\nfloat costh = x/r;\nfloat R = 1.;\nfloat Uinf = 1.;\n// radial flow\nfloat ur = Uinf*(1.-1.5*R/r+0.5*R*R*R/(r*r*r))*costh;\n// theta flow\nfloat uth = Uinf*(-1.+0.75*R/r+0.25*R*R*R/(r*r*r))*sinth;\n// to ux uy\nv.x = costh*ur-sinth*uth;\nv.y = sinth*ur+costh*uth;\n\n  return v;\n}",
  "particleCount": 7000
}, {
  "name": "Best vortex",
  "colorMode": 2,
  "cx": -6.158449999999998,
  "cy": -0.9834499999999995,
  "w": 96.8415,
  "h": 96.8415,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float r = length(p);\nfloat theta = atan(p.y, p.x);\nv = vec2(p.y, -p.x) / r;\nfloat t = sqrt(r * 10.) + theta + frame * .02;\nv *= sin(t);\nv *= length(v) * 10.;\nv += p * .2;\n\n  return v;\n}",
  "timeStep": 0.01,
  "fadeOut": 0.9,
  "dropProbability": 0.009,
  "particleCount": 100000
}, {
  "name": "Black hole",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": -0.47934999999999994,
  "cy": 0.3591500000000001,
  "w": 8.5397,
  "h": 8.5397,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float a = .1;\nfloat r2 = p.x * p.x + p.y * p.y;\nv = vec2(p.y, -p.x) / r2 - a * p;\n\n  return v;\n}"
}, {
  "name": "Julia set",
  "timeStep": 0.004,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": -0.40235,
  "cy": -0.01795000000000002,
  "w": 5.0845,
  "h": 5.0845,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  vec2 c = p;\nvec2 z = vec2(.4, .5);\nfor (int i = 0; i < 8; i++) {\n   c = vec2(c.x * c.x - c.y * c.y, c.y * c.x + c.x * c.y);\n   c += z;\n}\nv = c;\n\n\n  return v;\n}",
  "particleCount": 10000
}, {
  "name": "Mandelbrot set",
  "timeStep": 0.004,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 3,
  "cx": -0.5678,
  "cy": -0.07015000000000005,
  "w": 4.9902,
  "h": 4.9902,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  vec2 z = p;\nfor(int k=0; k<50; k++) {\nz = vec2(z.x * z.x - z.y * z.y, 2. * z.x * z.y) + p;\n}\n\nfloat mask = step(length(z), 2.);\nv.x = -p.y/length(p) * (0.5 - mask);\nv.y = p.x/length(p) * (0.5 - mask);\n\n\n\n\n  return v;\n}",
  "particleCount": 30000
}, {
  "name": "Reflecting pool",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": 0,
  "cy": 0,
  "w": 8.5398,
  "h": 8.5398,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  v.x = sin(5.0*p.y + p.x);\nv.y = cos(5.0*p.x - p.y);\n\n  return v;\n}"
}, {
  "name": "Shear zone",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 1,
  "cx": 0,
  "cy": 0,
  "w": 8.539734222673566,
  "h": 8.539734222673566,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float r = length(p) - 1.5;\nfloat c = 1.0/(1.0+exp(-5.0*r));\nfloat vx1 = -p.y,  // circle\n      vy1 = p.x;\nfloat vx2 = 0.2*p.x+p.y, // spiral\n      vy2 = 0.2*p.y-p.x;\nv.x = c*vx1 + (1.0-c)*vx2;\nv.y = c*vy1 + (1.0-c)*vy2;\n\n\n  return v;\n}"
}, {
  "name": "Beautiful field",
  "timeStep": 0.01,
  "fadeOut": 0.998,
  "dropProbability": 0.009,
  "colorMode": 3,
  "cx": -1.6564499999999995,
  "cy": -0.36424999999999974,
  "w": 24.7317,
  "h": 24.7317,
  "code": "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  float dt = 0.01;\nfloat t = frame*dt;\nfloat w = 2.*PI/5.;\nfloat A = 2.;\n\nfloat d = sqrt(p.x*p.x + p.y*p.y);\nv.x = A*cos(w*t/d);\nv.y = A*sin(w*t/d);\n\n  return v;\n}",
  "particleCount": 3000
}]);

/***/ }),

/***/ "7l3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);





/**
 * A tiny toy equation generator. It is very naive, and does silly things
 * sometimes. Feel free to improve.
 */

var cfProb = 10; // base probability to generate a point.

var probabilityClass = {
  POINT: cfProb,
  LENGTH: cfProb * 0.5,
  TRIGONOMETRY: cfProb * 0.9,
  ARITHMETICS: cfProb * 0.6,
  MINMAX: cfProb * 0.4,
  EXP: cfProb * 0.1,
  SIGN: cfProb * 0.01
};

var BaseFunctionNode = function () {
  function BaseFunctionNode(className) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, BaseFunctionNode);

    this.probability = 0;
    this.className = className;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(BaseFunctionNode, [{
    key: 'getProbability',
    value: function getProbability() {
      return probabilityClass[this.className];
    }
  }, {
    key: 'render',
    value: function render() {
      return '';
    }
  }]);

  return BaseFunctionNode;
}();

var SingleArgumentFunction = function (_BaseFunctionNode) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SingleArgumentFunction, _BaseFunctionNode);

  function SingleArgumentFunction(operator, p) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SingleArgumentFunction);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SingleArgumentFunction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SingleArgumentFunction)).call(this, p));

    _this.operator = operator;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(SingleArgumentFunction, [{
    key: 'render',
    value: function render() {
      var prevP = this.p;

      var prevP = this.getProbability();
      probabilityClass[this.className] *= 0.25;
      normalizeProbabilities();
      var args = generateArguments();
      probabilityClass[this.className] = prevP;
      normalizeProbabilities();
      return this.operator(args);
    }
  }]);

  return SingleArgumentFunction;
}(BaseFunctionNode);

var DualArgumentFunction = function (_BaseFunctionNode2) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DualArgumentFunction, _BaseFunctionNode2);

  function DualArgumentFunction(operator, p) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DualArgumentFunction);

    var _this2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DualArgumentFunction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DualArgumentFunction)).call(this, p));

    _this2.operator = operator;
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(DualArgumentFunction, [{
    key: 'render',
    value: function render() {
      // Decrease our probability to appear
      var prevP = this.getProbability();
      probabilityClass[this.className] *= 0.25;

      normalizeProbabilities();
      var left = generateArguments();
      var right = generateArguments();
      // revert it back;
      probabilityClass[this.className] = prevP;
      normalizeProbabilities();
      return this.operator(left, right);
    }
  }]);

  return DualArgumentFunction;
}(BaseFunctionNode);

var ConstantFunction = function (_BaseFunctionNode3) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ConstantFunction, _BaseFunctionNode3);

  function ConstantFunction(constant, p) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ConstantFunction);

    var _this3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ConstantFunction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ConstantFunction)).call(this, p));

    _this3.constant = constant;
    return _this3;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ConstantFunction, [{
    key: 'render',
    value: function render() {
      return this.constant;
    }
  }]);

  return ConstantFunction;
}(BaseFunctionNode);

var fList = [new ConstantFunction('p.x', 'POINT'), new ConstantFunction('p.y', 'POINT'),

// new DualArgumentFunction((a, b) => `length(vec2(${a}, ${b}))`, 'TRIGONOMETRY'),
new ConstantFunction('length(p)', 'LENGTH'), new SingleArgumentFunction(function (a) {
  return 'sin(' + a + ')';
}, 'TRIGONOMETRY'), new SingleArgumentFunction(function (a) {
  return 'cos(' + a + ')';
}, 'TRIGONOMETRY'),
// new SingleArgumentFunction(a => `sqrt(${a})`, cfProb * 0.8),
// new SingleArgumentFunction(a => `inversesqrt(${a})`, cfProb * 0.8),


new DualArgumentFunction(function (a, b) {
  return a + '*' + b;
}, 'ARITHMETICS'), new DualArgumentFunction(function (a, b) {
  return a + '/' + b;
}, 'ARITHMETICS'), new DualArgumentFunction(function (a, b) {
  return '(' + a + '+' + b + ')';
}, 'ARITHMETICS'), new DualArgumentFunction(function (a, b) {
  return '(' + a + '-' + b + ')';
}, 'ARITHMETICS'), new DualArgumentFunction(function (a, b) {
  if (a === b) return a;
  return 'min(' + a + ',' + b + ')';
}, 'MINMAX'), new DualArgumentFunction(function (a, b) {
  if (a === b) return a;
  return 'max(' + a + ',' + b + ')';
}, 'MINMAX'), new SingleArgumentFunction(function (a) {
  return 'log(' + a + ')';
}, 'EXP'), new SingleArgumentFunction(function (a) {
  return 'exp(' + a + ')';
}, 'EXP'), new DualArgumentFunction(function (a, b) {
  return 'pow(' + a + ', ' + b + ')';
}, 'EXP'), new SingleArgumentFunction(function (a) {
  return 'abs(' + a + ')';
}, 'SIGN'), new SingleArgumentFunction(function (a) {
  return 'sign(' + a + ')';
}, 'SIGN')];

function normalizeProbabilities() {
  var sum = 0;
  fList.forEach(function (element) {
    return sum += element.getProbability();
  });
  fList.forEach(function (element) {
    return element.probability = element.getProbability() / sum;
  });
}

function generateArguments() {
  var p = Math.random();
  var cumulativeProbability = 0;
  var item;
  for (var i = 0; i < fList.length; ++i) {
    item = fList[i];
    cumulativeProbability += item.probability;
    if (p < cumulativeProbability) {
      break;
    }
  }

  if (!item) throw new Error('no more items');

  return item.render();
}

function generate() {
  normalizeProbabilities();
  var vX = generateArguments();
  var vY = generateArguments();
  return 'v.x = ' + vX + ';\n  v.y = ' + vY + ';';
}

/***/ }),

/***/ "85ps":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getParsedVectorFieldFunction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__("eBcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pragmaParser__ = __webpack_require__("svlg");
/**
 * This module parses user defined vector field code.
 */




// This is naive parser that is being used until the real `glsl-parser`
// is loaded asynchronously. This parser assumes there are no errors
// TODO: maybe I should be more careful here?
var glslParser = {
  check: function check(code) {
    return {
      code: code,
      log: {
        errorCount: 0
      }
    };
  }
};

// glsl-parser is ~179KB uncompressed, we don't want to wait until it is downloaded.
// So we load it asynchronously...
__webpack_require__.e/* require.ensure */(2).then((function () {
  // ... and replace the naive parser with the real one, when ready.
  glslParser = __webpack_require__("TFw8");

  // notify interested parties, so that they can recheck code if they wish.
  __WEBPACK_IMPORTED_MODULE_0__bus___default.a.fire('glsl-parser-ready');
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

var vectorFieldGlobals = '\nimport {\n  float PI;\n  float snoise(vec2 v);\n  float frame;\n  vec4 cursor;\n  vec2 rotate(vec2 p,float a);\n  float audio(float index);\n  float rand(const vec2 co);\n  sampler2D input0;\n  sampler2D input1;\n}';

/**
 * Given a string, verifies that it is a valid glsl code for a vector field,
 * and then returns code + log.
 * 
 * @param {String} vectorFieldCode 
 */
function getParsedVectorFieldFunction(vectorFieldCode) {
  // TODO: what if we want to support 3d?
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__pragmaParser__["a" /* default */])(vectorFieldCode).then(function (pragmaParseResult) {
    if (pragmaParseResult.error) {
      return pragmaParseResult;
    }

    vectorFieldCode = pragmaParseResult.getCode();

    var parserResult = glslParser.check(vectorFieldCode, { globals: vectorFieldGlobals });
    parserResult.code = vectorFieldCode;

    if (parserResult.log.errorCount) parserResult.error = parserError(parserResult.log);

    return parserResult;
  });
}

function parserError(log) {
  var diag = log.diagnostics[0];
  // TODO probably need to check kind (errors are 0, warnings are 1)
  var firstError = diag.range;
  var lineColumn = firstError.lineColumn();
  var source = firstError.source;
  var offset = source._lineOffsets[lineColumn.line];
  var line = source.contents.substr(offset, lineColumn.column);
  line += source.contents.substring(firstError.start, firstError.end);
  var prefix = 'Line ' + lineColumn.line + ': ';
  var diagText = diag.text;
  return {
    error: prefix + line + '\n' + whitespace(prefix.length) + whitespace(lineColumn.column) + '^',
    errorDetail: diagText,
    isFloatError: isFloatError(diagText)
  };
}

function isFloatError(diagText) {
  return diagText.indexOf('"int"') > -1 && diagText.indexOf('"float"') > -1;
}

function whitespace(length) {
  return new Array(length + 1).join(' ');
}

/***/ }),

/***/ "94y8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__("eBcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gl_utils__ = __webpack_require__("Ddjs");



/* harmony default export */ __webpack_exports__["a"] = (audioProgram);

function audioProgram(ctx) {
  var gl = ctx.gl;

  var audioWidth = 8,
      audioHeight = 8;
  var audioBuffer = new Uint8Array(audioWidth * audioHeight * 4);
  var audioTexture = __WEBPACK_IMPORTED_MODULE_1__gl_utils__["a" /* default */].createTexture(gl, gl.NEAREST, audioBuffer, audioWidth, audioHeight);
  var audioDirty = false;
  ctx.audioTexture = audioTexture;

  __WEBPACK_IMPORTED_MODULE_0__bus___default.a.on('audio', updateAudioBuffer);

  return {
    updateTextures: updateTextures,
    dispose: dispose
  };

  function dispose() {
    __WEBPACK_IMPORTED_MODULE_0__bus___default.a.off('audio', updateAudioBuffer);
    gl.deleteTexture(audioTexture);
  }

  function updateTextures() {
    if (!audioDirty) return;
    audioDirty = false;

    // TODO: This should come from fftSize?
    var width = 5,
        height = 5;
    gl.bindTexture(gl.TEXTURE_2D, audioTexture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, audioBuffer);
    gl.bindTexture(gl.TEXTURE_2D, null);
  }

  function updateAudioBuffer(newBuffer) {
    audioBuffer = newBuffer;
    audioDirty = true;
  }
}

/***/ }),

/***/ "C8nW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = request;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/**
 * XMLHttpRequest wrapped into a promise.
 * 
 * @param {String} url 
 */
function request(url, options) {
  if (!options) options = {};

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(download);

  function download(resolve, reject) {
    var req = new XMLHttpRequest();

    if (typeof options.progress === 'function') {
      req.addEventListener('progress', updateProgress, false);
    }

    req.addEventListener('load', transferComplete, false);
    req.addEventListener('error', transferFailed, false);
    req.addEventListener('abort', transferCanceled, false);

    req.open('GET', url);
    if (options.responseType) {
      req.responseType = options.responseType;
    }
    req.send(null);

    function updateProgress(e) {
      if (e.lengthComputable) {
        options.progress({
          loaded: e.loaded,
          total: e.total,
          percent: e.loaded / e.total
        });
      }
    }

    function transferComplete() {
      if (req.status !== 200) {
        reject('Unexpected status code ' + req.status + ' when calling ' + url);
        return;
      }
      var response = req.response;

      if (options.responseType === 'json' && typeof response === 'string') {
        // IE
        response = JSON.parse(response);
      }

      resolve(response);
    }

    function transferFailed() {
      reject('Failed to download ' + url);
    }

    function transferCanceled() {
      reject('Cancelled download of ' + url);
    }
  }
}

/***/ }),

/***/ "Ddjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This file is based on https://github.com/mapbox/webgl-wind
 * by Vladimir Agafonkin
 * 
 * Released under ISC License, Copyright (c) 2016, Mapbox
 * https://github.com/mapbox/webgl-wind/blob/master/LICENSE
 * 
 * Adapted to field maps by Andrei Kashcha
 * Copyright (C) 2017
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  createTexture: createTexture,
  bindFramebuffer: bindFramebuffer,
  createProgram: createProgram,
  createBuffer: createBuffer,
  bindAttribute: bindAttribute,
  bindTexture: bindTexture
});

function bindTexture(gl, texture, unit) {
  gl.activeTexture(gl.TEXTURE0 + unit);
  gl.bindTexture(gl.TEXTURE_2D, texture);
}

function createBuffer(gl, data) {
  var buffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
  return buffer;
}

function createTexture(gl, filter, data, width, height) {
  var texture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filter);
  if (data instanceof Uint8Array) {
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
  } else {
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, data);
  }
  gl.bindTexture(gl.TEXTURE_2D, null);
  return texture;
}

function bindFramebuffer(gl, framebuffer, texture) {
  gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
  if (texture) {
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
  }
}

function bindAttribute(gl, buffer, attribute, numComponents) {
  gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.enableVertexAttribArray(attribute);
  gl.vertexAttribPointer(attribute, numComponents, gl.FLOAT, false, 0, 0);
}

function createProgram(gl, vertexSource, fragmentSource) {
  var program = gl.createProgram();

  var vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexSource);
  var fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentSource);

  gl.attachShader(program, vertexShader);
  gl.attachShader(program, fragmentShader);

  gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    throw new Error(gl.getProgramInfoLog(program));
  }

  var wrapper = {
    program: program,
    unload: unload
  };

  var numAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
  var i;
  for (i = 0; i < numAttributes; i++) {
    var attribute = gl.getActiveAttrib(program, i);
    wrapper[attribute.name] = gl.getAttribLocation(program, attribute.name);
  }
  var numUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
  for (i = 0; i < numUniforms; i++) {
    var uniform = gl.getActiveUniform(program, i);
    wrapper[uniform.name] = gl.getUniformLocation(program, uniform.name);
  }

  return wrapper;

  function unload() {
    gl.deleteProgram(program);
  }
}

function createShader(gl, type, source) {
  var shader = gl.createShader(type);
  gl.shaderSource(shader, source);

  gl.compileShader(shader);
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    throw new Error(gl.getShaderInfoLog(shader));
  }

  return shader;
}

/***/ }),

/***/ "DuZ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BaseShaderNode__ = __webpack_require__("4KA4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_simplex_noise__ = __webpack_require__("JjDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__customInput__ = __webpack_require__("bvb0");









var UserDefinedVelocityFunction = function (_BaseShaderNode) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(UserDefinedVelocityFunction, _BaseShaderNode);

  function UserDefinedVelocityFunction(updateCode) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UserDefinedVelocityFunction);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UserDefinedVelocityFunction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(UserDefinedVelocityFunction)).call(this));

    _this.updateCode = updateCode || '';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UserDefinedVelocityFunction, [{
    key: 'setNewUpdateCode',
    value: function setNewUpdateCode(newUpdateCode) {
      this.updateCode = newUpdateCode;
    }
  }, {
    key: 'getDefines',
    value: function getDefines() {
      return '\nuniform float frame;\nuniform vec4 cursor;\n// TODO: use inputN instead.\nuniform sampler2D u_audio;\n\n#define PI 3.1415926535897932384626433832795\n\n' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__customInput__["a" /* getInputUniforms */])() + '\n';
    }
  }, {
    key: 'getFunctions',
    value: function getFunctions() {
      // TODO: Do I need to worry about "glsl injection" (i.e. is there potential for security attack?)
      // TODO: Do I need to inject snoise only when it's used?
      return '\n    // pseudo-random generator\nconst vec3 rand_constants = vec3(12.9898, 78.233, 4375.85453);\nfloat rand(const vec2 co) {\n    float t = dot(rand_constants.xy, co);\n    return fract(sin(t) * (rand_constants.z + t));\n}\n\n' + __WEBPACK_IMPORTED_MODULE_6__parts_simplex_noise__["a" /* default */] + '\n\nvec2 rotate(vec2 p,float a) {\n\treturn cos(a)*p+sin(a)*vec2(p.y,-p.x);\n}\n\n// TODO: This will change. Don\'t use it.\nfloat audio(float index) {\n  float rgbI = floor(index/4.);\n  vec2 txPos = vec2(fract(rgbI / 5.), floor(rgbI / 5.) / 5.);\n  vec4 rgba = texture2D(u_audio, txPos);\n  \n  float offset = mod(index, 4.);\n  if (offset == 0.) return rgba[0];\n  if (offset == 1.) return rgba[1];\n  if (offset == 2.) return rgba[2];\n  return rgba[3];\n}\n\n' + (this.updateCode ? this.updateCode : 'vec2 get_velocity(vec2 p) { return vec2(0.); }') + '\n  ';
    }
  }]);

  return UserDefinedVelocityFunction;
}(__WEBPACK_IMPORTED_MODULE_5__BaseShaderNode__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (UserDefinedVelocityFunction);

/***/ }),

/***/ "FaU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = encodeFloatRGBA;
/* harmony export (immutable) */ __webpack_exports__["b"] = decodeFloatRGBA;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2__ = __webpack_require__("yI0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2__);

/**
 * This file encodes/decodes float values into 32bit rgba array
 * 
 * It is based on https://computergraphics.stackexchange.com/questions/4151/webgl-packing-unpacking-functions-that-can-roundtrip-all-typical-32-bit-floats
 * and it is not perfect. If you know how to improve it - please let me know.
 */

/**
 * Encodes float value into output array
 * @param {float} val - value to be encode
 * @param {Uint8Array} out  - array where encoded value needs to be written.
 * @param {Number} writeOffset - offset in the original array where values should be written.
 */
function encodeFloatRGBA(val, out, writeOffset) {
  if (val == 0.0) {
    out[writeOffset + 0] = 0;out[writeOffset + 1] = 0;out[writeOffset + 2] = 0;out[writeOffset + 3] = 0;
    return;
  }

  var mag = Math.abs(val);
  var exponent = Math.floor(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_log2___default()(mag));
  // Correct log2 approximation errors.
  exponent += exp2(exponent) <= mag / 2.0 ? 1 : 0;
  exponent -= exp2(exponent) > mag ? 1 : 0;

  var mantissa;
  if (exponent > 100.0) {
    mantissa = mag / 1024.0 / exp2(exponent - 10.0) - 1.0;
  } else {
    mantissa = mag / exp2(exponent) - 1.0;
  }

  var a = exponent + 127.0;
  mantissa *= 256.0;
  var b = Math.floor(mantissa);
  mantissa -= b;
  mantissa *= 256.0;
  var c = Math.floor(mantissa);
  mantissa -= c;
  mantissa *= 128.0;
  var d = Math.floor(mantissa) * 2.0 + (val < 0.0 ? 1 : 0);

  out[writeOffset + 0] = a;out[writeOffset + 1] = b;out[writeOffset + 2] = c;out[writeOffset + 3] = d;
}

/**
 * Given byte values in range [0..255] returns decoded float value.
 * 
 * @param {Byte} r 
 * @param {Byte} g 
 * @param {Byte} b 
 * @param {Byte} a 
 */
function decodeFloatRGBA(r, g, b, a) {
  var A = Math.floor(r + 0.5);
  var B = Math.floor(g + 0.5);
  var C = Math.floor(b + 0.5);
  var D = Math.floor(a + 0.5);

  var exponent = A - 127.0;
  var sign = 1.0 - D % 2.0 * 2.0;
  var mantissa = (A > 0.0 ? 1 : 0) + B / 256.0 + C / 65536.0 + Math.floor(D / 2.0) / 8388608.0;
  return sign * mantissa * exp2(exponent);
}

function exp2(exponent) {
  return Math.exp(exponent * Math.LN2);
}

/***/ }),

/***/ "I6d+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createImageInputBinding;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loadTexture__ = __webpack_require__("egvE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gl_utils__ = __webpack_require__("Ddjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("rvz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus__ = __webpack_require__("eBcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__bus__);
/**
 * Creates a single image binding element in the input collection.
 */





var FREE_TEXTURE_UNIT = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].FREE_TEXTURE_UNIT;

function createImageInputBinding(ctx, url, callbacks) {
  var texture = null;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__loadTexture__["a" /* default */])(ctx.gl, url).then(setTexture).catch(handleError);

  return {
    updateBinding: updateBinding,
    dispose: function dispose() {
      // TODO: Potential race condition, as loadTexture is async.
      ctx.gl.deleteTexture(texture);
    }
  };

  function handleError(err) {
    if (callbacks && callbacks.error) {
      callbacks.error(err);
    }
  }

  function setTexture(loadedTexture) {
    texture = loadedTexture;
    __WEBPACK_IMPORTED_MODULE_3__bus___default.a.fire('refresh-speed');
    if (callbacks && callbacks.done) {
      callbacks.done(url);
    }
  }

  function updateBinding(program, inputIndex) {
    if (!texture) return;

    var realIndex = inputIndex + FREE_TEXTURE_UNIT;
    __WEBPACK_IMPORTED_MODULE_1__gl_utils__["a" /* default */].bindTexture(ctx.gl, texture, realIndex);
    ctx.gl.uniform1i(program['input' + inputIndex], realIndex);
  }
}

/***/ }),

/***/ "JHsM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initScene;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gl_utils__ = __webpack_require__("Ddjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_panzoom__ = __webpack_require__("yBIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_panzoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_panzoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bus__ = __webpack_require__("eBcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appState__ = __webpack_require__("NEgR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__wglPanZoom__ = __webpack_require__("p0IO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__programs_screenProgram__ = __webpack_require__("h62Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__programs_drawParticlesProgram__ = __webpack_require__("pKWO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_cursorUpdater__ = __webpack_require__("p9aJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__editor_vectorFieldState__ = __webpack_require__("c5hq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__createInputsModel__ = __webpack_require__("/eR5");



/**
 * This file is based on https://github.com/mapbox/webgl-wind
 * by Vladimir Agafonkin
 *
 * Released under ISC License, Copyright (c) 2016, Mapbox
 * https://github.com/mapbox/webgl-wind/blob/master/LICENSE
 *
 * Adapted to field maps by Andrei Kashcha
 * Copyright (C) 2017
 */












/**
 * Kicks offs the app rendering. Initialized before even vue is loaded.
 *
 * @param {WebGLRenderingContext} gl
 */
function initScene(gl) {
  // Canvas size management
  var canvasRect = { width: 0, height: 0, top: 0, left: 0 };
  setWidthHeight(gl.canvas.width, gl.canvas.height);
  window.addEventListener('resize', onResize, true);

  // Video capturing is available in super advanced mode. You'll need to install
  // and start https://github.com/greggman/ffmpegserver.js
  // Then type in the console: window.startRecord();
  // This will trigger frame-by-frame recording (it is slow). To stop it, call window.stopRecord();
  __WEBPACK_IMPORTED_MODULE_5__bus___default.a.on('start-record', startRecord);
  __WEBPACK_IMPORTED_MODULE_5__bus___default.a.on('stop-record', stopRecord);
  var currentCapturer = null;

  // TODO: It feels like bounding box management needs to be moved out from here.
  // TODO: bbox needs to be a class with width/height properties.
  var bbox = __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getBBox() || {};
  var currentPanZoomTransform = {
    scale: 1,
    x: 0,
    y: 0
  };

  // How many particles do we want?
  var particleCount = __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getParticleCount();

  gl.disable(gl.DEPTH_TEST);
  gl.disable(gl.STENCIL_TEST);

  // Context variable is a way to share rendering state between multiple programs. It has a lot of stuff on it.
  // I found that it's the easiest way to work in state-full world of WebGL.
  // Until I discover a better way to write WebGL code.
  var ctx = {
    gl: gl,
    bbox: bbox,
    canvasRect: canvasRect,

    inputs: null,

    framebuffer: gl.createFramebuffer(),

    // This is used only to render full-screen rectangle. Main magic happens inside textures.
    quadBuffer: __WEBPACK_IMPORTED_MODULE_3__gl_utils__["a" /* default */].createBuffer(gl, new Float32Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1])),

    colorMode: __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getColorMode(),
    colorFunction: __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getColorFunction(),

    // This defines texture unit for screen rendering. First few indices are taken by textures
    // that compute particles position/color
    // TODO: I need to find a better way to manage this.
    screenTextureUnit: 3,

    integrationTimeStep: __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getIntegrationTimeStep(),

    // On each frame the likelihood for a particle to reset its position is this:
    dropProbability: __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getDropProbability(),

    // current frame number. Reset every time when new shader is compiled
    frame: 0,

    // Information about mouse cursor. Could be useful to simplify
    // exploration
    cursor: {
      // Where mouse was last time clicked (or tapped)
      clickX: 0, clickY: 0,
      // where mouse was last time moved. If this is a touch device
      // this is the same as clickX, clickY
      hoverX: 0, hoverY: 0
    },

    // Texture size to store particles' positions
    particleStateResolution: 0,

    // How quickly we should fade previous frame (from 0..1)
    fadeOpacity: __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getFadeout(),

    // Ignore this one for a moment. Yes, the app support web audio API,
    // but it's rudimentary, so... shhh! it's a secret.
    // Don't shhh on me!
    audioTexture: null
  };

  // Frame management
  var lastAnimationFrame;
  var isPaused = false;

  var inputsModel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__createInputsModel__["a" /* default */])(ctx);

  // screen rendering;
  var screenProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__programs_screenProgram__["a" /* default */])(ctx);
  var drawProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__programs_drawParticlesProgram__["a" /* default */])(ctx);
  var cursorUpdater = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_cursorUpdater__["a" /* default */])(ctx);
  var vectorFieldEditorState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__editor_vectorFieldState__["a" /* default */])(drawProgram);

  // particles
  updateParticlesCount(particleCount);

  var api = {
    start: nextFrame,
    stop: stop,
    dispose: dispose,

    resetBoundingBox: resetBoundingBox,
    moveBoundingBox: moveBoundingBox,
    applyBoundingBox: applyBoundingBox,

    setPaused: setPaused,

    getParticlesCount: getParticlesCount,
    setParticlesCount: setParticlesCount,

    setFadeOutSpeed: setFadeOutSpeed,
    getFadeOutSpeed: getFadeOutSpeed,

    setDropProbability: setDropProbability,
    getDropProbability: getDropProbability,

    getIntegrationTimeStep: getIntegrationTimeStep,
    setIntegrationTimeStep: setIntegrationTimeStep,

    setColorMode: setColorMode,
    getColorMode: getColorMode,

    vectorFieldEditorState: vectorFieldEditorState,

    inputsModel: inputsModel,

    getCanvasRect: function getCanvasRect() {
      // We trust they don't do anything bad with this ...
      return canvasRect;
    },
    getBoundingBox: function getBoundingBox() {
      // again, we trust. Maybe to much?
      return ctx.bbox;
    }
  };

  var panzoom = initPanzoom();
  restoreBBox();

  setTimeout(function () {
    __WEBPACK_IMPORTED_MODULE_5__bus___default.a.fire('scene-ready', api);
  });

  return api;

  function moveBoundingBox(changes) {
    if (!changes) return;
    var parsedBoundingBox = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, ctx.bbox);

    assignIfPossible(changes, 'minX', parsedBoundingBox);
    assignIfPossible(changes, 'minY', parsedBoundingBox);
    assignIfPossible(changes, 'maxX', parsedBoundingBox);
    assignIfPossible(changes, 'maxY', parsedBoundingBox);

    // for Y axis changes we need to preserve aspect ration, which means
    // we also need to change X...
    if (changes.minY !== undefined || changes.maxY !== undefined) {
      // adjust values for X
      var heightChange = Math.abs(parsedBoundingBox.minY - parsedBoundingBox.maxY) / Math.abs(ctx.bbox.minY - ctx.bbox.maxY);
      var cx = (ctx.bbox.maxX + ctx.bbox.minX) / 2;
      var prevWidth = (ctx.bbox.maxX - ctx.bbox.minX) / 2;
      parsedBoundingBox.minX = cx - prevWidth * heightChange;
      parsedBoundingBox.maxX = cx + prevWidth * heightChange;
    }

    applyBoundingBox(parsedBoundingBox);
  }

  function assignIfPossible(change, key, newBoundingBox) {
    var value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(change[key]);
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value)) {
      newBoundingBox[key] = value;
    }
  }

  function startRecord(capturer) {
    currentCapturer = capturer;
  }

  function stopRecord() {
    currentCapturer = null;
  }

  function setColorMode(x) {
    var mode = parseInt(x, 10);
    __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].setColorMode(mode);
    ctx.colorMode = __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getColorMode();
    drawProgram.updateColorMode(mode);
  }

  function getColorMode() {
    return __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getColorMode();
  }

  function getIntegrationTimeStep() {
    return __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getIntegrationTimeStep();
  }

  function setIntegrationTimeStep(x) {
    var f = parseFloat(x);
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(f)) {
      ctx.integrationTimeStep = f;
      __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].setIntegrationTimeStep(f);
      __WEBPACK_IMPORTED_MODULE_5__bus___default.a.fire('integration-timestep-changed', f);
    }
  }

  function setPaused(shouldPause) {
    isPaused = shouldPause;
    nextFrame();
  }

  // Main screen fade out configuration
  function setFadeOutSpeed(x) {
    var f = parseFloat(x);
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(f)) {
      ctx.fadeOpacity = f;
      __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].setFadeout(f);
    }
  }

  function getFadeOutSpeed() {
    return __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getFadeout();
  }

  // Number of particles configuration
  function getParticlesCount() {
    return __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getParticleCount();
  }

  function setParticlesCount(newParticleCount) {
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(newParticleCount)) return;
    if (newParticleCount === particleCount) return;
    if (newParticleCount < 1) return;

    updateParticlesCount(newParticleCount);

    particleCount = newParticleCount;
    __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].setParticleCount(newParticleCount);
  }

  // drop probability
  function setDropProbability(x) {
    var f = parseFloat(x);
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(f)) {
      // TODO: Do I need to worry about duplication/clamping?
      __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].setDropProbability(f);
      ctx.dropProbability = f;
    }
  }

  function getDropProbability() {
    return __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getDropProbability();
  }

  function onResize() {
    setWidthHeight(window.innerWidth, window.innerHeight);

    screenProgram.updateScreenTextures();

    updateBoundingBox(currentPanZoomTransform);
  }

  function setWidthHeight(w, h) {
    var dx = Math.max(w * 0.02, 30);
    var dy = Math.max(h * 0.02, 30);
    canvasRect.width = w + 2 * dx;
    canvasRect.height = h + 2 * dy;
    canvasRect.top = -dy;
    canvasRect.left = -dx;

    var canvas = gl.canvas;
    canvas.width = canvasRect.width;
    canvas.height = canvasRect.height;
    canvas.style.left = -dx + 'px';
    canvas.style.top = -dy + 'px';
  }

  function dispose() {
    stop();
    panzoom.dispose();
    window.removeEventListener('resize', onResize, true);
    cursorUpdater.dispose();
    vectorFieldEditorState.dispose();
  }

  function nextFrame() {
    if (lastAnimationFrame) return;

    if (isPaused) return;

    lastAnimationFrame = requestAnimationFrame(draw);
  }

  function stop() {
    cancelAnimationFrame(lastAnimationFrame);
    lastAnimationFrame = 0;
  }

  function draw() {
    lastAnimationFrame = 0;

    drawScreen();

    if (currentCapturer) currentCapturer.capture(gl.canvas);

    nextFrame();
  }

  function drawScreen() {
    screenProgram.fadeOutLastFrame();
    drawProgram.drawParticles();
    screenProgram.renderCurrentScreen();
    drawProgram.updateParticlesPositions();
  }

  function updateParticlesCount(numParticles) {
    // we create a square texture where each pixel will hold a particle position encoded as RGBA
    ctx.particleStateResolution = Math.ceil(Math.sqrt(numParticles));
    drawProgram.updateParticlesCount();
  }

  function initPanzoom() {
    var initializedPanzoom = __WEBPACK_IMPORTED_MODULE_4_panzoom___default()(gl.canvas, {
      controller: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__wglPanZoom__["a" /* default */])(gl.canvas, updateBoundingBox)
    });

    return initializedPanzoom;
  }

  function restoreBBox() {
    var savedBBox = __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].getBBox();
    var width = canvasRect.width,
        height = canvasRect.height;


    var sX = Math.PI * Math.E;
    var sY = Math.PI * Math.E;
    var tX = 0;
    var tY = 0;
    if (savedBBox) {
      sX = savedBBox.maxX - savedBBox.minX;
      sY = savedBBox.maxY - savedBBox.minY;
      // TODO: Not sure if this is really the best way to do it.
      // var ar = width/height;
      tX = width * (savedBBox.minX + savedBBox.maxX) / 2;
      tY = width * (savedBBox.minY + savedBBox.maxY) / 2;
    }

    var w2 = sX * width / 2;
    var h2 = sY * height / 2;
    panzoom.showRectangle({
      left: -w2 + tX,
      top: -h2 - tY,
      right: w2 + tX,
      bottom: h2 - tY
    });
  }

  function updateBoundingBox(transform) {
    screenProgram.boundingBoxUpdated = true;

    currentPanZoomTransform.x = transform.x;
    currentPanZoomTransform.y = transform.y;
    currentPanZoomTransform.scale = transform.scale;

    var width = canvasRect.width,
        height = canvasRect.height;


    var minX = clientX(0);
    var minY = clientY(0);
    var maxX = clientX(width);
    var maxY = clientY(height);

    // we divide by width to keep aspect ratio
    // var ar = width/height;
    var p = 10000;
    bbox.minX = Math.round(p * minX / width) / p;
    bbox.minY = Math.round(p * -minY / width) / p;
    bbox.maxX = Math.round(p * maxX / width) / p;
    bbox.maxY = Math.round(p * -maxY / width) / p;

    __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].saveBBox(bbox);

    __WEBPACK_IMPORTED_MODULE_5__bus___default.a.fire('bbox-change', bbox);

    function clientX(x) {
      return (x - transform.x) / transform.scale;
    }

    function clientY(y) {
      return (y - transform.y) / transform.scale;
    }
  }

  function resetBoundingBox() {
    var w = Math.PI * Math.E * 0.5;
    var h = Math.PI * Math.E * 0.5;

    applyBoundingBox({
      minX: -w,
      minY: -h,
      maxX: w,
      maxY: h
    });
  }

  function applyBoundingBox(boundingBox) {
    __WEBPACK_IMPORTED_MODULE_6__appState__["a" /* default */].saveBBox(boundingBox);
    restoreBBox();
    // a hack to trigger panzoom event
    panzoom.moveBy(0, 0, false);
  }
}

/***/ }),

/***/ "JjDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
// Description : Array and textureless GLSL 2D simplex noise function.
//      Author : Ian McEwan, Ashima Arts.
//  Maintainer : stegu
//     Lastmod : 20110822 (ijm)
//     License : Copyright (C) 2011 Ashima Arts. All rights reserved.
//               Distributed under the MIT License. See LICENSE file.
//               https://github.com/ashima/webgl-noise
//               https://github.com/stegu/webgl-noise
// 

var code = "\nvec3 mod289(vec3 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec2 mod289(vec2 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec3 permute(vec3 x) {\n  return mod289(((x*34.0)+1.0)*x);\n}\n\nfloat snoise(vec2 v)\n  {\n  const vec4 C = vec4(0.211324865405187,  // (3.0-sqrt(3.0))/6.0\n                      0.366025403784439,  // 0.5*(sqrt(3.0)-1.0)\n                     -0.577350269189626,  // -1.0 + 2.0 * C.x\n                      0.024390243902439); // 1.0 / 41.0\n// First corner\n  vec2 i  = floor(v + dot(v, C.yy) );\n  vec2 x0 = v -   i + dot(i, C.xx);\n\n// Other corners\n  vec2 i1;\n  //i1.x = step( x0.y, x0.x ); // x0.x > x0.y ? 1.0 : 0.0\n  //i1.y = 1.0 - i1.x;\n  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);\n  // x0 = x0 - 0.0 + 0.0 * C.xx ;\n  // x1 = x0 - i1 + 1.0 * C.xx ;\n  // x2 = x0 - 1.0 + 2.0 * C.xx ;\n  vec4 x12 = x0.xyxy + C.xxzz;\n  x12.xy -= i1;\n\n// Permutations\n  i = mod289(i); // Avoid truncation effects in permutation\n  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))\n\t\t+ i.x + vec3(0.0, i1.x, 1.0 ));\n\n  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);\n  m = m*m ;\n  m = m*m ;\n\n// Gradients: 41 points uniformly over a line, mapped onto a diamond.\n// The ring size 17*17 = 289 is close to a multiple of 41 (41*7 = 287)\n\n  vec3 x = 2.0 * fract(p * C.www) - 1.0;\n  vec3 h = abs(x) - 0.5;\n  vec3 ox = floor(x + 0.5);\n  vec3 a0 = x - ox;\n\n// Normalise gradients implicitly by scaling m\n// Approximation of: m *= inversesqrt( a0*a0 + h*h );\n  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );\n\n// Compute final noise value at P\n  vec3 g;\n  g.x  = a0.x  * x0.x  + h.x  * x0.y;\n  g.yz = a0.yz * x12.xz + h.yz * x12.yw;\n  return 130.0 * dot(m, g);\n}\n";

/* harmony default export */ __webpack_exports__["a"] = (code);

/***/ }),

/***/ "NEgR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_state__ = __webpack_require__("3zJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus__ = __webpack_require__("eBcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__programs_colorModes__ = __webpack_require__("6c6E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wrapVectorField__ = __webpack_require__("cj2E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isSmallScreen__ = __webpack_require__("bwl9");







/**
 * The state of the fieldplay is stored in the query string. This is the
 * only place where query string can be manipulated or fetched.
 */

var qs = __WEBPACK_IMPORTED_MODULE_1_query_state___default()({}, {
  useSearch: true,
  // Older version of the app used hash to store application arguments.
  // Turns out hash is not good for websites like reddit. They can block
  // url, saying "url was already submitted" if the only part that is different
  // is hash. So, we switch to search string, and maintain backward compatibility
  // for fields created before.
  rewriteHashToSearch: true
});

var currentState = qs.get();

var defaultVectorField = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__wrapVectorField__["a" /* default */])('v.x = 0.1 * p.y;\n  v.y = -0.2 * p.y;');

var pendingSave;
var defaults = {
  timeStep: 0.01,
  dropProbability: 0.009,
  particleCount: 10000,
  fadeout: .998,
  colorMode: __WEBPACK_IMPORTED_MODULE_3__programs_colorModes__["a" /* default */].UNIFORM
};

var settingsPanel = {
  collapsed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isSmallScreen__["a" /* default */])()
};

/* harmony default export */ __webpack_exports__["a"] = ({
  settingsPanel: settingsPanel,
  saveBBox: saveBBox,
  getBBox: getBBox,
  makeBBox: makeBBox,
  getQS: function getQS() {
    return qs;
  },

  saveCode: saveCode,
  getCode: getCode,
  getDefaultCode: getDefaultCode,

  getDropProbability: getDropProbability,
  setDropProbability: setDropProbability,

  getIntegrationTimeStep: getIntegrationTimeStep,
  setIntegrationTimeStep: setIntegrationTimeStep,

  getParticleCount: getParticleCount,
  setParticleCount: setParticleCount,

  getFadeout: getFadeout,
  setFadeout: setFadeout,

  getColorMode: getColorMode,
  setColorMode: setColorMode,

  getColorFunction: getColorFunction,
  setColorFunction: setColorFunction
});

qs.onChange(function () {
  __WEBPACK_IMPORTED_MODULE_2__bus___default.a.fire('scene-ready', window.scene);
});

function getColorMode() {
  var colorMode = qs.get('cm');
  return defined(colorMode) ? colorMode : defaults.colorMode;
}

function setColorMode(colorMode) {
  if (!defined(colorMode)) return;
  qs.set({ cm: colorMode });
  currentState.cm = colorMode;
}

function getColorFunction() {
  var colorFunction = qs.get('cf');
  return colorFunction || '';
}

function setColorFunction(colorFunction) {
  qs.set({ cf: colorFunction });
  currentState.cf = colorFunction;
}

function getFadeout() {
  var fadeout = qs.get('fo');
  return defined(fadeout) ? fadeout : defaults.fadeout;
}

function setFadeout(fadeout) {
  if (!defined(fadeout)) return;
  qs.set({ fo: fadeout });
  currentState.fo = fadeout;
}

function getParticleCount() {
  var particleCount = qs.get('pc');
  return defined(particleCount) ? particleCount : defaults.particleCount;
}

function setParticleCount(particleCount) {
  if (!defined(particleCount)) return;
  qs.set({ pc: particleCount });
  currentState.pc = particleCount;
}

function getIntegrationTimeStep() {
  var timeStep = qs.get('dt');
  return defined(timeStep) ? timeStep : defaults.timeStep;
}

function setIntegrationTimeStep(dt) {
  if (!defined(dt)) return;
  qs.set({ dt: dt });
  currentState.dt = dt;
}

function getDropProbability() {
  var dropProbability = qs.get('dp');
  return defined(dropProbability) ? dropProbability : defaults.dropProbability;
}

function setDropProbability(dropProbability) {
  if (!defined(dropProbability)) return;
  clamp(dropProbability, 0, 1);
  qs.set({ dp: dropProbability });
}

function getBBox() {
  var cx = qs.get('cx');
  var cy = qs.get('cy');
  var w = qs.get('w');
  var h = qs.get('h');
  return makeBBox(cx, cy, w, h);
}

function makeBBox(cx, cy, w, h) {
  var bboxDefined = defined(cx) && defined(cy) && defined(w) && defined(h);
  if (!bboxDefined) return;

  var w2 = w / 2;
  var h2 = h / 2;
  var p = 10000;
  return {
    minX: Math.round(p * (cx - w2)) / p,
    maxX: Math.round(p * (cx + w2)) / p,
    minY: Math.round(p * (cy - h2)) / p,
    maxY: Math.round(p * (cy + h2)) / p
  };
}

function saveBBox(bbox) {
  var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  bbox = {
    cx: (bbox.minX + bbox.maxX) * 0.5,
    cy: (bbox.minY + bbox.maxY) * 0.5,
    w: bbox.maxX - bbox.minX,
    h: bbox.maxX - bbox.minX
  };

  if (bbox.w <= 0 || bbox.h <= 0) return;

  currentState.cx = bbox.cx;
  currentState.cy = bbox.cy;
  currentState.w = bbox.w;
  currentState.h = bbox.h;

  if (pendingSave) {
    clearTimeout(pendingSave);
    pendingSave = 0;
  }

  if (immediate) qs.set(bbox);else {
    pendingSave = setTimeout(function () {
      pendingSave = 0;
      qs.set(bbox);
    }, 300);
  }
}

function getCode() {
  var vfCode = qs.get('vf');
  if (vfCode) return vfCode;

  // If we didn't get code yet, let's try read to read it from previous version
  // of the API.
  // TODO: Need to figure out how to develop this in backward/future compatible way.
  var oldCode = qs.get('code');
  if (oldCode) {
    vfCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__wrapVectorField__["a" /* default */])(oldCode);
    // side effect - let's clean the old URL
    delete currentState.code;
    qs.set('vf', vfCode);
    return vfCode;
  }

  return defaultVectorField;
}

function getDefaultCode() {
  return defaultVectorField;
}

function saveCode(code) {
  qs.set({
    vf: code
  });
  currentState.code = code;
}

function defined(number) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(number);
}

function clamp(x, min, max) {
  return x < min ? min : x > max ? max : x;
}

/***/ }),

/***/ "Qv35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BaseShaderNode__ = __webpack_require__("4KA4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TexturePositionNode__ = __webpack_require__("XMEc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__renderNodes__ = __webpack_require__("S+/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserDefinedVelocityFunction__ = __webpack_require__("DuZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PanzoomTransform__ = __webpack_require__("vhRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RungeKuttaIntegrator__ = __webpack_require__("i69e");












var UpdatePositionGraph = function () {
  function UpdatePositionGraph(options) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, UpdatePositionGraph);

    this.readStoredPosition = new __WEBPACK_IMPORTED_MODULE_6__TexturePositionNode__["a" /* default */]( /* isDecode = */true);
    this.udfVelocity = new __WEBPACK_IMPORTED_MODULE_8__UserDefinedVelocityFunction__["a" /* default */]();
    this.integratePositions = new __WEBPACK_IMPORTED_MODULE_10__RungeKuttaIntegrator__["a" /* default */]();
    this.dropParticles = new RandomParticleDropper();
    this.writeComputedPosition = new __WEBPACK_IMPORTED_MODULE_6__TexturePositionNode__["a" /* default */]( /* isDecode = */false);
    this.panZoomDecode = new __WEBPACK_IMPORTED_MODULE_9__PanzoomTransform__["a" /* default */]({ decode: true });
    this.panZoomEncode = new __WEBPACK_IMPORTED_MODULE_9__PanzoomTransform__["a" /* default */]({ decode: false });

    this.colorMode = options && options.colorMode;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(UpdatePositionGraph, [{
    key: 'setCustomVectorField',
    value: function setCustomVectorField(velocityCode) {
      this.udfVelocity.setNewUpdateCode(velocityCode);
    }
  }, {
    key: 'getVertexShader',
    value: function getVertexShader() {
      return 'precision highp float;\n\nattribute vec2 a_pos;\nvarying vec2 v_tex_pos;\nuniform vec2 u_min;\nuniform vec2 u_max;\n\nvoid main() {\n    v_tex_pos = a_pos;\n    gl_Position = vec4(1.0 - 2.0 * a_pos, 0, 1);\n}';
    }
  }, {
    key: 'getFragmentShader',
    value: function getFragmentShader() {
      var nodes = [this.readStoredPosition, this.dropParticles, this.udfVelocity, this.integratePositions, {
        getMainBody: function getMainBody() {
          return '\n  vec2 newPos = pos + velocity;\n  ';
        }
      }, this.writeComputedPosition];
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__renderNodes__["a" /* default */])(nodes);
    }
  }]);

  return UpdatePositionGraph;
}();

/* harmony default export */ __webpack_exports__["a"] = (UpdatePositionGraph);

var RandomParticleDropper = function (_BaseShaderNode) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RandomParticleDropper, _BaseShaderNode);

  function RandomParticleDropper() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RandomParticleDropper);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RandomParticleDropper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RandomParticleDropper)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RandomParticleDropper, [{
    key: 'getDefines',
    value: function getDefines() {
      return '\nuniform float u_drop_rate;\nuniform float u_rand_seed;\nuniform vec2 u_min;\nuniform vec2 u_max;\n';
    }
  }, {
    key: 'getFunctions',
    value: function getFunctions() {
      // TODO: Ideally this node should probably depend on
      // random number generator node, so that we don't duplicate code
      return '\n';
    }
  }, {
    key: 'getMainBody',
    value: function getMainBody() {
      return '\n  // a random seed to use for the particle drop\n  vec2 seed = (pos + v_tex_pos) * u_rand_seed;\n  // drop rate is a chance a particle will restart at random position, to avoid degeneration\n  float drop = step(1.0 - u_drop_rate, rand(seed));\n\n  // TODO: This can be customized to produce various emitters\n  // random_pos is in range from 0..1, we move it to the bounding box:\n  vec2 random_pos = vec2(rand(seed + 1.9), rand(seed + 8.4)) * (u_max - u_min) + u_min;\n  pos = mix(pos, random_pos, drop);\n';
    }
  }]);

  return RandomParticleDropper;
}(__WEBPACK_IMPORTED_MODULE_5__BaseShaderNode__["a" /* default */]);

/***/ }),

/***/ "S+/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderNodes;

function renderNodes(nodes) {
  var code = [];

  nodes.forEach(function (node) {
    if (node.getDefines) addToCode(node.getDefines());
  });
  nodes.forEach(function (node) {
    if (node.getFunctions) addToCode(node.getFunctions());
  });

  addToCode('void main() {');
  nodes.forEach(function (node) {
    if (node.getMainBody) addToCode(node.getMainBody());
  });
  addToCode('}');
  return code.join('\n');

  function addToCode(line) {
    if (line) code.push(line);
  }
}

/***/ }),

/***/ "V39N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeStatCounter;
/**
 * A simple interface to compute eventual min/max 
 */
function makeStatCounter() {
  var min, max;

  var api = {
    getMin: function getMin() {
      return min;
    },
    getMax: function getMax() {
      return max;
    },
    add: function add(x) {
      if (x < min) min = x;
      if (x > max) max = x;
    },

    reset: reset
  };

  return api;

  function reset() {
    min = Number.POSITIVE_INFINITY;
    max = Number.NEGATIVE_INFINITY;
  }
}

/***/ }),

/***/ "XFig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A shader function to decode rgba encoded color into float position.
 */
var code = "\nhighp float decodeFloatRGBA( vec4 v ) {\n  float a = floor(v.r * 255.0 + 0.5);\n  float b = floor(v.g * 255.0 + 0.5);\n  float c = floor(v.b * 255.0 + 0.5);\n  float d = floor(v.a * 255.0 + 0.5);\n\n  float exponent = a - 127.0;\n  float sign = 1.0 - mod(d, 2.0)*2.0;\n  float mantissa = float(a > 0.0)\n                  + b / 256.0\n                  + c / 65536.0\n                  + floor(d / 2.0) / 8388608.0;\n  return sign * mantissa * exp2(exponent);\n}\n";

/* harmony default export */ __webpack_exports__["a"] = (code);

/***/ }),

/***/ "XMEc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BaseShaderNode__ = __webpack_require__("4KA4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_encodeFloatRGBA__ = __webpack_require__("a8s+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_decodeFloatRGBA__ = __webpack_require__("XFig");









/**
 * Reads/writes particle coordinates from/to a texture;
 */

var TexturePosition = function (_BaseShaderNode) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TexturePosition, _BaseShaderNode);

  function TexturePosition(isDecode) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TexturePosition);

    // When it's decoding, it must read from the texture.
    // Otherwise it must write to the texture;
    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TexturePosition.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TexturePosition)).call(this));

    _this.isDecode = isDecode;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TexturePosition, [{
    key: 'getFunctions',
    value: function getFunctions() {
      if (this.isDecode) {
        return '\n    ' + __WEBPACK_IMPORTED_MODULE_6__parts_encodeFloatRGBA__["a" /* default */] + '\n    ' + __WEBPACK_IMPORTED_MODULE_7__parts_decodeFloatRGBA__["a" /* default */] + '\n';
      }
    }
  }, {
    key: 'getDefines',
    value: function getDefines() {
      if (this.isDecode) {
        // TODO: How to avoid duplication and silly checks?
        return '\nprecision highp float;\n\nuniform sampler2D u_particles_x;\nuniform sampler2D u_particles_y;\n\n// Which coordinate needs to be printed onto the texture\nuniform int u_out_coordinate;\n\nvarying vec2 v_tex_pos;\n';
      }
    }
  }, {
    key: 'getMainBody',
    value: function getMainBody() {
      if (this.isDecode) {
        return '\n   vec2 pos = vec2(\n     decodeFloatRGBA(texture2D(u_particles_x, v_tex_pos)),\n     decodeFloatRGBA(texture2D(u_particles_y, v_tex_pos))\n   );\n';
      }
      return '\n    if (u_out_coordinate == 0) gl_FragColor = encodeFloatRGBA(newPos.x);\n    else if (u_out_coordinate == 1) gl_FragColor = encodeFloatRGBA(newPos.y);\n    else if (u_out_coordinate == 6) gl_FragColor = encodeFloatRGBA(get_velocity(pos).x);\n    else if (u_out_coordinate == 7) gl_FragColor = encodeFloatRGBA(get_velocity(pos).y);\n';
    }
  }]);

  return TexturePosition;
}(__WEBPACK_IMPORTED_MODULE_5__BaseShaderNode__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TexturePosition);

/***/ }),

/***/ "YJWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scene__ = __webpack_require__("JHsM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__("eBcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__autoMode__ = __webpack_require__("sbZs");
/**
 * The main entry point to the application.
 *
 * It is initialized immediately with webgl, and puts
 * vue.js app loading into the future.
 */




var canvas = document.getElementById('scene');
// Canvas may not be available in test run
if (canvas) initVectorFieldApp(canvas);

// Tell webpack to split bundle, and download settings UI later.
__webpack_require__.e/* require.ensure */(0).then((function () {
  // Settings UI is ready, initialize vue.js application
  __webpack_require__("WOBu");
}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

function initVectorFieldApp(canvas) {
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  var ctxOptions = { antialiasing: false };

  var gl = canvas.getContext('webgl', ctxOptions) || canvas.getContext('experimental-webgl', ctxOptions);

  if (gl) {
    window.webGLEnabled = true;
    var scene = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__scene__["a" /* default */])(gl);
    scene.start();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__autoMode__["a" /* initAutoMode */])(scene);
    window.scene = scene;
  } else {
    window.webGLEnabled = false;
  }
}

var CCapture;
var currentCapturer;

window.startRecord = startRecord;
window.isRecording = false;

function startRecord(url) {
  if (!CCapture) {
    __webpack_require__.e/* require.ensure */(1).then((function () {
      CCapture = __webpack_require__("nI+d");
      window.stopRecord = stopRecord;
      startRecord(url);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

    return;
  }

  if (currentCapturer) {
    currentCapturer.stop();
  }

  if (!ffmpegScriptLoaded()) {
    var ffmpegServer = document.createElement('script');
    ffmpegServer.setAttribute('src', url || 'http://localhost:8080/ffmpegserver/ffmpegserver.js');
    ffmpegServer.onload = function () {
      return startRecord(url);
    };
    document.head.appendChild(ffmpegServer);
    return;
  }

  currentCapturer = new CCapture({
    format: 'ffmpegserver',
    framerate: 60,
    verbose: true,
    name: "fieldplay",
    extension: ".mp4",
    codec: "mpeg4",
    ffmpegArguments: ["-b:v", "12M"]
  });

  window.isRecording = true;
  currentCapturer.start();
  __WEBPACK_IMPORTED_MODULE_1__bus___default.a.fire('start-record', currentCapturer);
}

function ffmpegScriptLoaded() {
  return typeof FFMpegServer !== 'undefined';
}

function stopRecord() {
  window.isRecording = false;
  __WEBPACK_IMPORTED_MODULE_1__bus___default.a.fire('stop-record', currentCapturer);
  currentCapturer.stop();
  currentCapturer.save();
}

/***/ }),

/***/ "a8s+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var code = "\nvec4 encodeFloatRGBA(highp float val) {\n    if (val == 0.0) {\n        return vec4(0.0, 0.0, 0.0, 0.0);\n    }\n\n    float mag = abs(val);\n    float exponent = floor(log2(mag));\n    // Correct log2 approximation errors.\n    exponent += float(exp2(exponent) <= mag / 2.0);\n    exponent -= float(exp2(exponent) > mag);\n\n    float mantissa;\n    if (exponent > 100.0) {\n        // Not sure why this needs to be done in two steps for the largest float to work.\n        // Best guess is the optimizer rewriting '/ exp2(e)' into '* exp2(-e)',\n        // but exp2(-128.0) is too small to represent.\n        mantissa = mag / 1024.0 / exp2(exponent - 10.0) - 1.0;\n    } else {\n        mantissa = mag / float(exp2(exponent)) - 1.0;\n    }\n\n    float a = exponent + 127.0;\n    mantissa *= 256.0;\n    float b = floor(mantissa);\n    mantissa -= b;\n    mantissa *= 256.0;\n    float c = floor(mantissa);\n    mantissa -= c;\n    mantissa *= 128.0;\n    float d = floor(mantissa) * 2.0 + float(val < 0.0);\n    return vec4(a, b, c, d) / 255.0;\n}\n";

/* harmony default export */ __webpack_exports__["a"] = (code);

/***/ }),

/***/ "aZPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_decodeFloatRGBA__ = __webpack_require__("XFig");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shaderBasedColor__ = __webpack_require__("c5NW");





// TODO: this duplicates code from texture position.

var DrawParticleGraph = function () {
  function DrawParticleGraph(ctx) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DrawParticleGraph);

    this.colorMode = ctx.colorMode;
    this.colorFunction = ctx.colorFunction || '';
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DrawParticleGraph, [{
    key: 'getFragmentShader',
    value: function getFragmentShader() {
      return 'precision highp float;\nvarying vec4 v_particle_color;\nvoid main() {\n  gl_FragColor = v_particle_color;\n}';
    }
  }, {
    key: 'getVertexShader',
    value: function getVertexShader(vfCode) {
      var decodePositions = textureBasedPosition();
      var colorParts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shaderBasedColor__["a" /* default */])(this.colorMode, vfCode, this.colorFunction);
      var methods = [];
      addMethods(decodePositions, methods);
      addMethods(colorParts, methods);
      var main = [];
      addMain(decodePositions, main);
      addMain(colorParts, main);

      return 'precision highp float;\nattribute float a_index;\nuniform float u_particles_res;\nuniform vec2 u_min;\nuniform vec2 u_max;\n\n' + (decodePositions.getVariables() || '') + '\n' + colorParts.getVariables() + '\n\n' + __WEBPACK_IMPORTED_MODULE_2__parts_decodeFloatRGBA__["a" /* default */] + '\n\n' + methods.join('\n') + '\n\nvoid main() {\n  vec2 txPos = vec2(\n        fract(a_index / u_particles_res),\n        floor(a_index / u_particles_res) / u_particles_res);\n  gl_PointSize = 1.0;\n\n' + main.join('\n') + '\n\n  vec2 du = (u_max - u_min);\n  v_particle_pos = (v_particle_pos - u_min)/du;\n  gl_Position = vec4(2.0 * v_particle_pos.x - 1.0, (1. - 2. * (v_particle_pos.y)),  0., 1.);\n}';
    }
  }]);

  return DrawParticleGraph;
}();

/* harmony default export */ __webpack_exports__["a"] = (DrawParticleGraph);


function addMethods(producer, array) {
  if (producer.getMethods) {
    array.push(producer.getMethods());
  }
}

function addMain(producer, array) {
  if (producer.getMain) {
    array.push(producer.getMain());
  }
}

function textureBasedPosition() {
  return {
    getVariables: getVariables,
    getMain: getMain
  };

  function getVariables() {
    return '\nuniform sampler2D u_particles_x;\nuniform sampler2D u_particles_y;\n    ';
  }

  function getMain() {
    return '\n  vec2 v_particle_pos = vec2(\n    decodeFloatRGBA(texture2D(u_particles_x, txPos)),\n    decodeFloatRGBA(texture2D(u_particles_y, txPos))\n  );\n';
  }
}

/***/ }),

/***/ "bvb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getInputUniforms;
function getInputUniforms() {
  return "uniform sampler2D input0;\nuniform sampler2D input1;";
}

/***/ }),

/***/ "bwl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSmallScreen;
/**
 * Checks whether current window belongs to a "Small" screen
 * size. Small screens have slightly different initial behavior.
 * E.g. the settings window is always collapsed.
 * 
 * This needs to be in sync with `small-screen` variable in
 *  ../commponents/shared.styl
 */
function isSmallScreen() {
  return window.innerWidth < 600;
}

/***/ }),

/***/ "c5NW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shaderBasedColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserDefinedVelocityFunction__ = __webpack_require__("DuZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RungeKuttaIntegrator__ = __webpack_require__("i69e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__programs_colorModes__ = __webpack_require__("6c6E");




function shaderBasedColor(colorMode, vfCode, colorCode) {
  var udf = new __WEBPACK_IMPORTED_MODULE_0__UserDefinedVelocityFunction__["a" /* default */](vfCode);
  var integrate = new __WEBPACK_IMPORTED_MODULE_1__RungeKuttaIntegrator__["a" /* default */]();

  return {
    getVariables: getVariables,
    getMain: getMain,
    getMethods: getMethods
  };

  function getVariables() {
    return '\nuniform vec2 u_velocity_range;\nvarying vec4 v_particle_color;\n\n' + udf.getDefines() + '\n' + integrate.getDefines() + '\n';
  }

  function getMethods() {
    return '\n// https://github.com/hughsk/glsl-hsv2rgb\nvec3 hsv2rgb(vec3 c) {\n  vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\n  vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n  return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n}\n\n' + udf.getFunctions() + '\n' + integrate.getFunctions() + '\n' + getColorFunctionBody() + '\n';
  }

  function getColorFunctionBody() {
    if (colorMode === __WEBPACK_IMPORTED_MODULE_2__programs_colorModes__["a" /* default */].UNIFORM) {
      return '\nvec4 get_color(vec2 p) {\n  return vec4(0.302, 0.737, 0.788, 1.);\n}\n';
    }
    if (colorMode === __WEBPACK_IMPORTED_MODULE_2__programs_colorModes__["a" /* default */].VELOCITY) {
      return '\nvec4 get_color(vec2 p) {\n  vec2 velocity = get_velocity(p);\n  float speed = (length(velocity) - u_velocity_range[0])/(u_velocity_range[1] - u_velocity_range[0]);\n  return vec4(hsv2rgb(vec3(0.05 + (1. - speed) * 0.5, 0.9, 1.)), 1.0);\n}\n';
    }

    if (colorMode === __WEBPACK_IMPORTED_MODULE_2__programs_colorModes__["a" /* default */].CUSTOM) {
      if (!colorCode) throw new Error('color mode is set to custom, but no color function is specified');

      return colorCode;
    }

    return ' \nvec4 get_color(vec2 p) {\n  vec2 velocity = get_velocity(p);\n  float speed = (atan(velocity.y, velocity.x) + PI)/(2.0 * PI);\n  return vec4(hsv2rgb(vec3(speed, 0.9, 1.)), 1.0);\n}\n';
  }

  function getMain() {
    return '  v_particle_color = get_color(v_particle_pos);';
  }
}

/***/ }),

/***/ "c5hq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createVectorFieldEditorState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__("eBcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appState__ = __webpack_require__("NEgR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getParsedVectorFieldFunction__ = __webpack_require__("85ps");




/**
 * A text editor state for the vector field equation. Manages vector field
 * program compilation and error reporting state.
 *
 * @param {Object} drawProgram 
 */
function createVectorFieldEditorState(drawProgram) {
  __WEBPACK_IMPORTED_MODULE_0__bus___default.a.on('glsl-parser-ready', parseCode);
  var currentVectorFieldVersion = 0;

  // What is the current code?
  var currentVectorFieldCode = __WEBPACK_IMPORTED_MODULE_1__appState__["a" /* default */].getCode();

  // For delayed parsing result verification (e.g. when vue is loaded it
  // can request us to see if there were any errors)
  var parserResult;

  loadCodeFromAppState();

  var api = {
    getCode: getCode,
    setCode: setCode,
    dispose: dispose,

    // These properties are for UI only
    code: currentVectorFieldCode,
    error: '',
    errorDetail: '',
    isFloatError: false
  };

  return api;

  function dispose() {
    __WEBPACK_IMPORTED_MODULE_0__bus___default.a.off('glsl-parser-ready', parseCode);
  }

  function getCode() {
    return __WEBPACK_IMPORTED_MODULE_1__appState__["a" /* default */].getCode();
  }

  function setCode(vectorFieldCode) {
    if (vectorFieldCode === currentVectorFieldCode) {
      // If field hasn't changed, let's make sure that there was no previous
      // error
      if (parserResult && parserResult.error) {
        // And if there was error, let's revalidate code:
        parseCode();
      }
      return;
    }

    trySetNewCode(vectorFieldCode).then(function (result) {
      if (result.cancelled) return;

      if (result && result.error) {
        updateErrorInfo(result.error);
        return result;
      }

      currentVectorFieldCode = vectorFieldCode;
      api.code = vectorFieldCode;
      __WEBPACK_IMPORTED_MODULE_1__appState__["a" /* default */].saveCode(vectorFieldCode);
    });
  }

  function updateErrorInfo(parserResult) {
    if (parserResult && parserResult.error) {
      api.error = parserResult.error;
      api.errorDetail = parserResult.errorDetail;
      api.isFloatError = parserResult.isFloatError;
    } else {
      api.error = '';
      api.errorDetail = '';
      api.isFloatError = false;
    }
  }

  function loadCodeFromAppState() {
    var persistedCode = __WEBPACK_IMPORTED_MODULE_1__appState__["a" /* default */].getCode();
    if (persistedCode) {
      trySetNewCode(persistedCode).then(function (result) {
        if (!result.error) return; // This means we set correctly;
        // If we get here - something went wrong. see the console
        console.error('Failed to restore previous vector field: ', result.error);
        // Let's use default vector field
        trySetNewCode(__WEBPACK_IMPORTED_MODULE_1__appState__["a" /* default */].getDefaultCode());
      });
    } else {
      // we want a default vector field
      trySetNewCode(__WEBPACK_IMPORTED_MODULE_1__appState__["a" /* default */].getDefaultCode());
    }
  }

  function parseCode(customCode) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getParsedVectorFieldFunction__["a" /* default */])(customCode || currentVectorFieldCode).then(function (currentResult) {
      parserResult = currentResult;
      updateErrorInfo(parserResult.error);
      return parserResult;
    });
  }

  function trySetNewCode(vectorFieldCode) {
    currentVectorFieldVersion += 1;
    var capturedVersion = currentVectorFieldVersion;
    // step 1 - run through parser
    return parseCode(vectorFieldCode).then(function (parserResult) {
      if (capturedVersion !== currentVectorFieldVersion) {
        parserResult.cancelled = true;
        // a newer request was issued. Ignore these results.
        return parserResult;
      }

      if (parserResult.error) {
        return parserResult;
      }
      // step 2 - run through real webgl
      try {
        drawProgram.updateCode(parserResult.code);
        return parserResult;
      } catch (e) {
        return {
          error: {
            error: e.message
          }
        };
      }
    });
  }
}

/***/ }),

/***/ "cj2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapVectorField;
/**
 * Wraps a simple vector field string into our default shader code.
 * @param {String} field 
 */
function wrapVectorField(field) {
  return "// p.x and p.y are current coordinates\n// v.x and v.y is a velocity at point p\nvec2 get_velocity(vec2 p) {\n  vec2 v = vec2(0., 0.);\n\n  // change this to get a new vector field\n  " + field + "\n\n  return v;\n}";
}

/***/ }),

/***/ "eBcr":
/***/ (function(module, exports, __webpack_require__) {

/**
 * A simple message bus. Facilitates uncoupled communication between
 * components of fieldplay.
 */
var eventify = __webpack_require__("puH/");

module.exports = eventify({});

/***/ }),

/***/ "egvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadTexture;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

// https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Tutorial/Using_textures_in_WebGL
function loadTexture(gl, url) {
  var resolveTexture, rejectTexture;

  var image = new Image();
  image.crossOrigin = '';

  image.onload = bindTexture;
  image.onerror = reportError;
  image.src = url;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    resolveTexture = resolve;
    rejectTexture = reject;
  });

  function reportError(err) {
    rejectTexture(err);
  }

  function bindTexture() {
    var texture = gl.createTexture();
    var level = 0;
    var internalFormat = gl.RGBA;
    var srcFormat = gl.RGBA;
    var srcType = gl.UNSIGNED_BYTE;
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, image);

    if (isPowerOf2(image.width) && isPowerOf2(image.height)) {
      gl.generateMipmap(gl.TEXTURE_2D);
    } else {
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    }

    resolveTexture(texture);
  }
}

function isPowerOf2(value) {
  return (value & value - 1) == 0;
}

/***/ }),

/***/ "gIFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = colorProgram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gl_utils__ = __webpack_require__("Ddjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__("eBcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_floatPacking__ = __webpack_require__("FaU1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_makeStatCounter__ = __webpack_require__("V39N");





var OUT_V_X = 6;
var OUT_V_Y = 7;
/**
 * This program allows to change color of each particle. It works by
 * reading current velocities into a texture from the framebuffer. Once
 * velocities are read, it checks velocity scale and passes it to a draw program.
 */
function colorProgram(ctx) {
  var speedNeedsUpdate = true;
  var gl = ctx.gl;

  var velocity_y_texture, velocity_x_texture;
  var particleStateResolution;
  var pendingSpeedUpdate;
  var numParticles;
  var velocityCounter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_makeStatCounter__["a" /* default */])();
  var velocity_x;
  var velocity_y;

  listenToEvents();

  return {
    updateCode: updateCode,
    updateParticlesPositions: updateParticlesPositions,
    updateParticlesCount: updateParticlesCount,
    setColorMinMax: setColorMinMax,
    requestSpeedUpdate: requestSpeedUpdate,
    dispose: dispose
  };

  function listenToEvents() {
    __WEBPACK_IMPORTED_MODULE_1__bus___default.a.on('integration-timestep-changed', requestSpeedUpdate);
    __WEBPACK_IMPORTED_MODULE_1__bus___default.a.on('bbox-change', requestSpeedUpdate);
    __WEBPACK_IMPORTED_MODULE_1__bus___default.a.on('refresh-speed', requestSpeedUpdate);
  }

  function dispose() {
    __WEBPACK_IMPORTED_MODULE_1__bus___default.a.off('integration-timestep-changed', requestSpeedUpdate);
    __WEBPACK_IMPORTED_MODULE_1__bus___default.a.off('bbox-change', requestSpeedUpdate);
    __WEBPACK_IMPORTED_MODULE_1__bus___default.a.off('refresh-speed', requestSpeedUpdate);
    disposeTextures();
  }

  function disposeTextures() {
    if (velocity_x_texture) gl.deleteTexture(velocity_x_texture);
    if (velocity_y_texture) gl.deleteTexture(velocity_y_texture);
  }

  function requestSpeedUpdate() {
    if (pendingSpeedUpdate) clearTimeout(pendingSpeedUpdate);
    pendingSpeedUpdate = setTimeout(function () {
      speedNeedsUpdate = true;
      pendingSpeedUpdate = 0;
    }, 50);
  }

  function setColorMinMax(program) {
    gl.uniform2f(program.u_velocity_range, velocityCounter.getMin(), velocityCounter.getMax());
  }

  function updateParticlesCount() {
    disposeTextures();

    particleStateResolution = ctx.particleStateResolution;
    numParticles = particleStateResolution * particleStateResolution;

    velocity_x = new Uint8Array(numParticles * 4);
    velocity_y = new Uint8Array(numParticles * 4);
    velocity_x_texture = __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].createTexture(gl, gl.NEAREST, velocity_x, particleStateResolution, particleStateResolution);
    velocity_y_texture = __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].createTexture(gl, gl.NEAREST, velocity_y, particleStateResolution, particleStateResolution);

    requestSpeedUpdate();
  }

  function updateCode() {
    requestSpeedUpdate();
  }

  function updateParticlesPositions(program) {
    if (!speedNeedsUpdate || !velocity_x || !velocity_y) return;
    speedNeedsUpdate = false;

    // We assume this is called from update position program
    __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindFramebuffer(gl, ctx.framebuffer, velocity_x_texture);
    gl.uniform1i(program.u_out_coordinate, OUT_V_X);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    gl.readPixels(0, 0, particleStateResolution, particleStateResolution, gl.RGBA, gl.UNSIGNED_BYTE, velocity_x);

    __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindFramebuffer(gl, ctx.framebuffer, velocity_y_texture);
    gl.uniform1i(program.u_out_coordinate, OUT_V_Y);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    gl.readPixels(0, 0, particleStateResolution, particleStateResolution, gl.RGBA, gl.UNSIGNED_BYTE, velocity_y);

    updateMinMax();
  }

  function updateMinMax() {
    velocityCounter.reset();
    // TODO: Do I want this to be async?
    for (var i = 0; i < velocity_y.length; i += 4) {
      var vx = readFloat(velocity_x, i);
      var vy = readFloat(velocity_y, i);
      var v = Math.sqrt(vx * vx + vy * vy);
      velocityCounter.add(v);
    }
  }
}

function readFloat(buffer, offset) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_floatPacking__["b" /* decodeFloatRGBA */])(buffer[offset + 0], buffer[offset + 1], buffer[offset + 2], buffer[offset + 3]);
}

/***/ }),

/***/ "h62Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeScreenProgram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gl_utils__ = __webpack_require__("Ddjs");
/**
 * Renders computed state onto the screen.
 */


var NO_TRANSFORM = { dx: 0, dy: 0, scale: 1 };

function makeScreenProgram(ctx) {
  var gl = ctx.gl,
      canvasRect = ctx.canvasRect;


  var screenTexture, backgroundTexture;
  var boundBoxTextureTransform = { dx: 0, dy: 0, scale: 1 };
  var lastRenderedBoundingBox = null;

  // TODO: Allow customization? Last time I tried, I didn't like it too much.
  // It was very easy to screw up the design, and the tool looked ugly :-/
  var backgroundColor = { r: 19 / 255, g: 41 / 255, b: 79 / 255, a: 1 };

  updateScreenTextures();
  var screenProgram = __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].createProgram(gl, getScreenVertexShader(), getScreenFragmentShader());

  var api = {
    fadeOutLastFrame: fadeOutLastFrame,
    renderCurrentScreen: renderCurrentScreen,
    updateScreenTextures: updateScreenTextures,

    boundingBoxUpdated: false
  };

  return api;

  function fadeOutLastFrame() {
    // render to the frame buffer
    __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindFramebuffer(gl, ctx.framebuffer, screenTexture);
    gl.viewport(0, 0, canvasRect.width, canvasRect.height);

    if (api.boundingBoxUpdated && lastRenderedBoundingBox) {
      // We move the back texture, relative to the bounding box change. This eliminates
      // particle train artifacts, though, not all of them: https://computergraphics.stackexchange.com/questions/5754/fading-particles-and-transition
      // If you know how to improve this - please let me know.
      boundBoxTextureTransform.dx = -(ctx.bbox.minX - lastRenderedBoundingBox.minX) / (ctx.bbox.maxX - ctx.bbox.minX);
      boundBoxTextureTransform.dy = -(ctx.bbox.minY - lastRenderedBoundingBox.minY) / (ctx.bbox.maxY - ctx.bbox.minY);
      boundBoxTextureTransform.scale = (ctx.bbox.maxX - ctx.bbox.minX) / (lastRenderedBoundingBox.maxX - lastRenderedBoundingBox.minX);
      drawTexture(backgroundTexture, ctx.fadeOpacity, boundBoxTextureTransform);
    } else {
      drawTexture(backgroundTexture, ctx.fadeOpacity, NO_TRANSFORM);
    }
  }

  function renderCurrentScreen() {
    __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindFramebuffer(gl, null);

    saveLastBbox();

    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.clearColor(backgroundColor.r, backgroundColor.g, backgroundColor.b, backgroundColor.a);
    gl.clear(gl.COLOR_BUFFER_BIT);
    drawTexture(screenTexture, 1.0, NO_TRANSFORM);
    gl.disable(gl.BLEND);

    var temp = backgroundTexture;
    backgroundTexture = screenTexture;
    screenTexture = temp;

    api.boundingBoxUpdated = false;
    if (window.audioTexture) {
      drawTexture(window.audioTexture, 1.0, NO_TRANSFORM);
    }
  }

  function updateScreenTextures() {
    var width = canvasRect.width,
        height = canvasRect.height;

    var emptyPixels = new Uint8Array(width * height * 4);
    if (screenTexture) {
      gl.deleteTexture(screenTexture);
    }
    if (backgroundTexture) {
      gl.deleteTexture(backgroundTexture);
    }

    screenTexture = __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].createTexture(gl, gl.NEAREST, emptyPixels, width, height);
    backgroundTexture = __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].createTexture(gl, gl.NEAREST, emptyPixels, width, height);
  }

  function saveLastBbox() {
    if (!lastRenderedBoundingBox) {
      lastRenderedBoundingBox = {
        minX: ctx.bbox.minX,
        minY: ctx.bbox.minY,
        maxX: ctx.bbox.maxX,
        maxY: ctx.bbox.maxY
      };

      return;
    }

    lastRenderedBoundingBox.minX = ctx.bbox.minX;
    lastRenderedBoundingBox.minY = ctx.bbox.minY;
    lastRenderedBoundingBox.maxX = ctx.bbox.maxX;
    lastRenderedBoundingBox.maxY = ctx.bbox.maxY;
  }

  function drawTexture(texture, opacity, textureTransform) {
    var program = screenProgram;
    gl.useProgram(program.program);
    __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindAttribute(gl, ctx.quadBuffer, program.a_pos, 2);

    // TODO: This index is very fragile. I need to find a way
    __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindTexture(gl, texture, ctx.screenTextureUnit);
    gl.uniform1i(program.u_screen, ctx.screenTextureUnit);

    gl.uniform1f(program.u_opacity_border, 0.02);
    gl.uniform1f(program.u_opacity, opacity);
    gl.uniform3f(program.u_transform, textureTransform.dx, textureTransform.dy, textureTransform.scale);

    gl.drawArrays(gl.TRIANGLES, 0, 6);
  }
}

function getScreenVertexShader() {
  return '// screen program\nprecision highp float;\n\nattribute vec2 a_pos;\nvarying vec2 v_tex_pos;\nuniform vec3 u_transform;\n\nvoid main() {\n    v_tex_pos = a_pos;\n    vec2 pos = a_pos;\n\n    // This transformation tries to move texture (raster) to the approximate position\n    // of particles on the current frame. This is needed to avoid rendering artifacts\n    // during pan/zoom: https://computergraphics.stackexchange.com/questions/5754/fading-particles-and-transition\n\n    // PS: I must admit, I wrote this formula through sweat and tears, and\n    // I still have no idea why I don\'t need to apply (pos.y - 0.5) to Y coordinate.\n    // Is it because I use aspect ratio for bounding box?\n    pos.x = (pos.x - 0.5) / u_transform.z - u_transform.x + 0.5 * u_transform.z;\n    pos.y = pos.y / u_transform.z + u_transform.y;\n\n    pos = 1.0 - 2.0 * pos;\n    gl_Position = vec4(pos, 0, 1);\n}';
}

function getScreenFragmentShader() {
  return 'precision highp float;\nuniform sampler2D u_screen;\nuniform float u_opacity;\nuniform float u_opacity_border;\n\nvarying vec2 v_tex_pos;\n\nvoid main() {\n  vec2 p = 1.0 - v_tex_pos;\n  vec4 color = texture2D(u_screen, p);\n\n  // For some reason particles near border leave trace when we translate the texture\n  // This is my dirty hack to fix it: https://computergraphics.stackexchange.com/questions/5754/fading-particles-and-transition\n  if (p.x < u_opacity_border || p.x > 1. - u_opacity_border || p.y < u_opacity_border || p.y > 1. - u_opacity_border) {\n    gl_FragColor = vec4(0.);\n  } else {\n    // opacity fade out even with a value close to 0.0\n    gl_FragColor = vec4(floor(255.0 * color * u_opacity) / 255.0);\n  }\n}';
}

/***/ }),

/***/ "i69e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BaseShaderNode__ = __webpack_require__("4KA4");







var RungeKuttaIntegrator = function (_BaseShaderNode) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RungeKuttaIntegrator, _BaseShaderNode);

  function RungeKuttaIntegrator() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RungeKuttaIntegrator);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RungeKuttaIntegrator.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RungeKuttaIntegrator)).call(this));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RungeKuttaIntegrator, [{
    key: 'getDefines',
    value: function getDefines() {
      return '\nuniform float u_h;\n';
    }
  }, {
    key: 'getFunctions',
    value: function getFunctions() {
      return '\nvec2 rk4(const vec2 point) {\n  vec2 k1 = get_velocity( point );\n  vec2 k2 = get_velocity( point + k1 * u_h * 0.5);\n  vec2 k3 = get_velocity( point + k2 * u_h * 0.5);\n  vec2 k4 = get_velocity( point + k3 * u_h);\n\n  return k1 * u_h / 6. + k2 * u_h/3. + k3 * u_h/3. + k4 * u_h/6.;\n}';
    }
  }, {
    key: 'getMainBody',
    value: function getMainBody() {
      return '\n  vec2 velocity = rk4(pos);\n';
    }
  }]);

  return RungeKuttaIntegrator;
}(__WEBPACK_IMPORTED_MODULE_5__BaseShaderNode__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (RungeKuttaIntegrator);

/***/ }),

/***/ "iw7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchGLSL;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_request__ = __webpack_require__("C8nW");


var loadedLinks = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(); // from link to response


function fetchGLSL(link) {
  if (!link) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('Missing link');
  var trimmed = link.trim();
  if (!trimmed) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('Missing link');

  var cachedResponse = loadedLinks.get(trimmed);
  if (cachedResponse) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cachedResponse);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_request__["a" /* default */])(link).then(function (code) {
    loadedLinks.set(link, code);
    return code;
  });
}

/***/ }),

/***/ "n67P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createInputCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);

/**
 * Collection of input bindings. Individual program works with this collection
 * to command it update texture bindings.
 */
function createInputCollection() {
  var boundInputs = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
  var currentProgram;
  return {
    updateBindings: updateBindings,
    bindInput: bindInput
  };

  function bindInput(inputIndex, inputBinding) {
    var prevBinding = boundInputs.get(inputIndex);
    if (prevBinding) {
      prevBinding.dispose();
    }
    boundInputs.set(inputIndex, inputBinding);
  }

  function updateBindings(program) {
    currentProgram = program;
    boundInputs.forEach(updateInputBinding);
  }

  function updateInputBinding(input, inputIndex) {
    input.updateBinding(currentProgram, inputIndex);
  }
}

/***/ }),

/***/ "p0IO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wglPanZoom;
/**
 * Enables panning and zooming of canvas with vector field
 * 
 * @param {HTMLCanvasElement} canvas that needs to be panned and zoomed
 * @param {*} updateBoundingBoxCallback callback that is called when vector field bounding box
 * needs to be updated
 */
function wglPanZoom(canvas, updateBoundingBoxCallback) {
  var lastDx = 0;
  var lastDy = 0;
  var lastScale = 1;

  // We need to be moved at least this many pixels in order to let
  // transform update bounding box.
  var transformThreshold = 2.1;

  return {
    applyTransform: function applyTransform(newTransform) {
      var dx = newTransform.x;
      var dy = newTransform.y;

      var dScale = lastScale - newTransform.scale;
      if (dScale === 0 && Math.abs(dx - lastDx) < transformThreshold && Math.abs(dy - lastDy) < transformThreshold) {
        // Wait for larger transform
        return;
      }

      lastDx = dx;
      lastDy = dy;
      lastScale = newTransform.scale;

      updateBoundingBoxCallback(newTransform);
    },
    getOwner: function getOwner() {
      return canvas;
    }
  };
}

/***/ }),

/***/ "p2DF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("rvz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gl_utils__ = __webpack_require__("Ddjs");



function createVideoInput(ctx, url) {
  var playing = false;
  var timeupdate = false;
  var copyVideo = false;

  var video = setupVideo();
  var currentFrame = createTexture();

  return {
    updateBinding: updateBinding,
    dispose: dispose
  };

  function updateBinding(program, inputIndex) {
    var realIndex = inputIndex + __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].FREE_TEXTURE_UNIT;
    __WEBPACK_IMPORTED_MODULE_1__gl_utils__["a" /* default */].bindTexture(ctx.gl, currentFrame, realIndex);
    if (copyVideo) updateTexture(ctx.gl);
    ctx.gl.uniform1i(program['input' + inputIndex], realIndex);
  }

  function updateTexture(gl) {
    var level = 0;
    var internalFormat = gl.RGBA;
    var srcFormat = gl.RGBA;
    var srcType = gl.UNSIGNED_BYTE;
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, video);
  }

  function createTexture() {
    var gl = ctx.gl;
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);

    var level = 0;
    var internalFormat = gl.RGBA;
    var width = 1;
    var height = 1;
    var border = 0;
    var srcFormat = gl.RGBA;
    var srcType = gl.UNSIGNED_BYTE;
    var pixel = new Uint8Array([0, 0, 255, 255]);
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, pixel);

    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);

    return texture;
  }
  function dispose() {
    video.removeEventListener('playing', onPlaying, true);
    video.removeEventListener('timeupdate', onTimeUpdate, true);
  }

  function setupVideo() {
    var video = document.createElement('video');
    video.crossOrigin = '';
    video.autoplay = true;
    video.muted = true;
    video.loop = true;

    // Waiting for these 2 events ensures there is data in the video
    video.addEventListener('playing', onPlaying, true);
    video.addEventListener('timeupdate', onTimeUpdate, true);

    video.src = url;
    video.play();

    return video;
  }

  function checkReady() {
    if (playing && timeupdate) {
      copyVideo = true;
    }
  }
  function onPlaying() {
    playing = true;
    checkReady();
  }

  function onTimeUpdate() {
    timeupdate = true;
    checkReady();
  }
}

/***/ }),

/***/ "p9aJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCursorUpdater;
/**
 * This module allows to pass mouse coordinates down to the shader. Coordinates
 * will be available as `vec4 cursor` variable, where `xy` are the last
 * click position, and `zw` are the last hover position.
 * 
 * Note: On Touch devices hover is the same click.
 * 
 * Hopefully this will enables easier exploration
 */
function createCursorUpdater(ctx) {
  var canvasRect = ctx.canvasRect,
      bbox = ctx.bbox;


  window.addEventListener('mousemove', onMouseMove, true);
  window.addEventListener('mousedown', onMouseClick, true);
  window.addEventListener('touchstart', onTouchStart, true);
  window.addEventListener('touchmove', onTouchMove, true);

  return {
    dispose: dispose
  };

  function dispose() {
    window.removeEventListener('mousemove', onMouseMove, true);
    window.removeEventListener('mousedown', onMouseClick, true);
    window.removeEventListener('touchstart', onTouchStart, true);
    window.removeEventListener('touchmove', onTouchMove, true);
  }

  function onTouchStart(e) {
    var firstTouch = e.touches[0];
    if (!firstTouch) return;

    setClick(firstTouch.clientX, firstTouch.clientY);
    setHover(firstTouch.clientX, firstTouch.clientY);
  }

  function onTouchMove(e) {
    var firstTouch = e.touches[0];
    if (!firstTouch) return;
    setHover(firstTouch.clientX, firstTouch.clientY);
  }

  function onMouseMove(e) {
    setHover(e.clientX, e.clientY);
  }

  function onMouseClick(e) {
    setClick(e.clientX, e.clientY);
  }

  function setHover(clientX, clientY) {
    ctx.cursor.hoverX = getSceneXFromClientX(clientX);
    ctx.cursor.hoverY = getSceneYFromClientY(clientY);
  }

  function setClick(clientX, clientY) {
    ctx.cursor.clickX = getSceneXFromClientX(clientX);
    ctx.cursor.clickY = getSceneYFromClientY(clientY);
  }

  function getSceneXFromClientX(clientX) {
    var dx = (clientX - canvasRect.left) / canvasRect.width;
    return (bbox.maxX - bbox.minX) * dx + bbox.minX;
  }

  function getSceneYFromClientY(clientY) {
    var dy = 1. - (clientY - canvasRect.top) / canvasRect.height;
    return (bbox.minY - bbox.maxY) * dy + bbox.maxY;
  }
}

/***/ }),

/***/ "pKWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = drawParticlesProgram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gl_utils__ = __webpack_require__("Ddjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shaderGraph_DrawParticleGraph__ = __webpack_require__("aZPT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__updatePositionProgram__ = __webpack_require__("3xg8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_floatPacking_js__ = __webpack_require__("FaU1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("rvz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__audioProgram__ = __webpack_require__("94y8");







/**
 * This program manages particles life-cycle. It updates particles positions
 * and initiates drawing them on screen.
 * 
 * @param {Object} ctx rendering context. Holds WebGL state
 */
function drawParticlesProgram(ctx) {
  var gl = ctx.gl;

  var particleStateResolution, particleIndexBuffer;
  var numParticles;

  var currentVectorField = '';
  var updatePositionProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__updatePositionProgram__["a" /* default */])(ctx);
  var audioProgram;

  var drawProgram;
  initPrograms();

  return {
    updateParticlesCount: updateParticlesCount,
    updateParticlesPositions: updateParticlesPositions,
    drawParticles: drawParticles,
    updateCode: updateCode,
    updateColorMode: updateColorMode
  };

  function initPrograms() {
    // need to update the draw graph because color mode shader has changed.
    initDrawProgram();

    if (__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].isAudioEnabled) {
      if (audioProgram) audioProgram.dispose();
      audioProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__audioProgram__["a" /* default */])(ctx);
    }
  }

  function initDrawProgram() {
    if (drawProgram) drawProgram.unload();

    var drawGraph = new __WEBPACK_IMPORTED_MODULE_1__shaderGraph_DrawParticleGraph__["a" /* default */](ctx);
    var vertexShaderCode = drawGraph.getVertexShader(currentVectorField);
    drawProgram = __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].createProgram(gl, vertexShaderCode, drawGraph.getFragmentShader());
  }

  function updateParticlesPositions() {
    if (!currentVectorField) return;

    ctx.frame += 1;
    ctx.frameSeed = Math.random();

    // TODO: Remove this.
    if (audioProgram) audioProgram.updateTextures();

    updatePositionProgram.updateParticlesPositions();
  }

  function updateColorMode() {
    initDrawProgram();
  }

  function updateCode(vfCode) {
    ctx.frame = 0;
    currentVectorField = vfCode;
    updatePositionProgram.updateCode(vfCode);

    initDrawProgram();
  }

  function updateParticlesCount() {
    particleStateResolution = ctx.particleStateResolution;
    numParticles = particleStateResolution * particleStateResolution;
    var particleIndices = new Float32Array(numParticles);
    var particleStateX = new Uint8Array(numParticles * 4);
    var particleStateY = new Uint8Array(numParticles * 4);

    var minX = ctx.bbox.minX;var minY = ctx.bbox.minY;
    var width = ctx.bbox.maxX - minX;
    var height = ctx.bbox.maxY - minY;
    for (var i = 0; i < numParticles; i++) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_floatPacking_js__["a" /* encodeFloatRGBA */])(Math.random() * width + minX, particleStateX, i * 4); // randomize the initial particle positions
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_floatPacking_js__["a" /* encodeFloatRGBA */])(Math.random() * height + minY, particleStateY, i * 4); // randomize the initial particle positions

      particleIndices[i] = i;
    }

    if (particleIndexBuffer) gl.deleteBuffer(particleIndexBuffer);
    particleIndexBuffer = __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].createBuffer(gl, particleIndices);

    updatePositionProgram.updateParticlesCount(particleStateX, particleStateY);
  }

  function drawParticles() {
    if (!currentVectorField) return;

    var program = drawProgram;
    gl.useProgram(program.program);

    __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindAttribute(gl, particleIndexBuffer, program.a_index, 1);

    updatePositionProgram.prepareToDraw(program);
    ctx.inputs.updateBindings(program);

    gl.uniform1f(program.u_h, ctx.integrationTimeStep);
    gl.uniform1f(program.frame, ctx.frame);
    gl.uniform1f(program.u_particles_res, particleStateResolution);
    var bbox = ctx.bbox;
    gl.uniform2f(program.u_min, bbox.minX, bbox.minY);
    gl.uniform2f(program.u_max, bbox.maxX, bbox.maxY);

    var cursor = ctx.cursor;
    gl.uniform4f(program.cursor, cursor.clickX, cursor.clickY, cursor.hoverX, cursor.hoverY);
    gl.drawArrays(gl.POINTS, 0, numParticles);
  }
}

/***/ }),

/***/ "pXNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = textureCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gl_utils__ = __webpack_require__("Ddjs");
/**
 * A wrapper over collection of textures. Can be used to represent
 * individual textures for every dimension.
 */


function textureCollection(gl, dimensions, particleStateResolution) {
  var textures = dimensions.map(function (d, index) {
    var textureInfo = {
      texture: __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].createTexture(gl, gl.NEAREST, d.particleState, particleStateResolution, particleStateResolution),
      index: index,
      name: d.name
    };

    return textureInfo;
  });

  return {
    dispose: dispose,
    bindTextures: bindTextures,
    assignProgramUniforms: assignProgramUniforms,
    length: dimensions.length,
    textures: textures,
    get: function get(i) {
      return textures[i];
    }
  };

  function assignProgramUniforms(program) {
    textures.forEach(function (tInfo) {
      gl.uniform1i(program['u_particles_' + tInfo.name], tInfo.index);
    });
  }

  function dispose() {
    textures.forEach(function (tInfo) {
      return gl.deleteTexture(tInfo.texture);
    });
  }

  function bindTextures(gl, program) {
    textures.forEach(function (tInfo) {
      __WEBPACK_IMPORTED_MODULE_0__gl_utils__["a" /* default */].bindTexture(gl, tInfo.texture, tInfo.index);
      gl.uniform1i(program['u_particles_' + tInfo.name], tInfo.index);
    });
  }
}

/***/ }),

/***/ "rvz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appState__ = __webpack_require__("NEgR");


var defaultConfig = {
  // I need to flash our more details before making any promises.
  isAudioEnabled: false,
  // this allows to render an overlay grid with vectors. Enable it
  // and drag the scene a little bit.
  vectorLinesEnabled: false,

  // Starting from which texture unit we can bind custom inputs?
  FREE_TEXTURE_UNIT: 4,

  // whether input bindings should be visible
  showBindings: __WEBPACK_IMPORTED_MODULE_0__appState__["a" /* default */].getQS().get('showBindings') || false
};

/* harmony default export */ __webpack_exports__["a"] = (defaultConfig);

/***/ }),

/***/ "sbZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAutoMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appState__ = __webpack_require__("NEgR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__autoPresets__ = __webpack_require__("7QEO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generate_equation__ = __webpack_require__("7l3+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wrapVectorField__ = __webpack_require__("cj2E");








var delayTime = void 0,
    incomingPresetsQueue = void 0,
    scene = void 0,
    scheduledUpdate = void 0,
    autoSource = void 0;

function initAutoMode(_scene) {
  scene = _scene;

  var qs = __WEBPACK_IMPORTED_MODULE_3__appState__["a" /* default */].getQS();

  autoSource = qs.get('autosource');
  if (!['presets', 'generator', 'both'].includes(autoSource)) {
    if (autoSource) {
      console.error('unknown autosource param; options are presets, generator, or both');
    }

    autoSource = 'both';
  }

  var autoTime = qs.get('autotime');
  if (!autoTime) {
    autoTime = qs.get('auto'); // Backwards compatibility
    if (!autoTime) {
      return;
    }

    console.warn('the auto param is deprecated; please use autotime');
  }

  var parsedMilliseconds = parseFloat(autoTime);
  if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(parsedMilliseconds)) {
    console.error('malformed autotime param; not a number');
    return;
  }

  if (/ms$/i.test(autoTime)) {
    // Already good
  } else if (/s$/i.test(autoTime)) {
    parsedMilliseconds *= 1000; // Convert from seconds
  } else if (/m$/i.test(autoTime)) {
    parsedMilliseconds *= 1000 * 60; // Convert from minutes
  } else if (/h$/i.test(autoTime)) {
    parsedMilliseconds *= 1000 * 60 * 60; // Convert from hours
  }

  if (parsedMilliseconds <= 500) {
    console.warn('autotime param is too small; defaulting to 30 seconds');
    parsedMilliseconds = 30000;
  }

  delayTime = parsedMilliseconds;
  next({ immediately: true });

  // TODO: When user changes any argument of a field, we need to stop the mode.
  // we could use `bus` here to listen for change events, and dispose.
  return dispose;
}

function dispose() {
  clearTimeout(scheduledUpdate);
  scheduledUpdate = 0;
  // TODO: When disposed we need to drop the `auto` argument from the query string.
  // otherwise if people share it, they can unintentionally switch on auto mode
}

function next(options) {
  options = options || {};

  var source = autoSource;
  if (source === 'both') {
    source = Math.random() < 0.5 ? 'presets' : 'generator';
  }

  if (source === 'generator') {
    scene.setParticlesCount(10000);
    scene.vectorFieldEditorState.setCode(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__wrapVectorField__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__generate_equation__["a" /* default */])()));
  } else if (source === 'presets') {
    if (!incomingPresetsQueue || !incomingPresetsQueue.length) {
      incomingPresetsQueue = shuffle(__WEBPACK_IMPORTED_MODULE_4__autoPresets__["a" /* default */]);
    }

    var preset = incomingPresetsQueue.shift();

    scene.vectorFieldEditorState.setCode(preset.code);

    if (defined(preset.colorMode)) {
      scene.setColorMode(preset.colorMode);
    }

    if (defined(preset.timeStep)) {
      scene.setIntegrationTimeStep(preset.timeStep);
    }

    if (defined(preset.fadeOut)) {
      scene.setFadeOutSpeed(preset.fadeOut);
    }

    if (defined(preset.dropProbability)) {
      scene.setDropProbability(preset.dropProbability);
    }

    if (defined(preset.particleCount)) {
      scene.setParticlesCount(preset.particleCount);
    }

    var bbox = __WEBPACK_IMPORTED_MODULE_3__appState__["a" /* default */].makeBBox(preset.cx, preset.cy, preset.w, preset.h);
    if (bbox) {
      if (options.immediately) {
        scene.applyBoundingBox(bbox);
      } else {
        animateBBox(bbox);
      }
    }

    // TODO: support these additional params: i0, showBindings
  }

  scheduledUpdate = setTimeout(next, delayTime);
}

function animateBBox(endBBox) {
  var startBBox = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, scene.getBoundingBox());
  var duration = 3000;
  var startTime = Date.now();
  var diffMinX = endBBox.minX - startBBox.minX;
  var diffMaxX = endBBox.maxX - startBBox.maxX;
  var diffMinY = endBBox.minY - startBBox.minY;
  var diffMaxY = endBBox.maxY - startBBox.maxY;

  var frame = function frame() {
    var factor = (Date.now() - startTime) / duration;
    if (factor >= 1) {
      scene.applyBoundingBox(endBBox);
      return;
    }

    requestAnimationFrame(frame);

    var bbox = {
      minX: startBBox.minX + diffMinX * factor,
      maxX: startBBox.maxX + diffMaxX * factor,
      minY: startBBox.minY + diffMinY * factor,
      maxY: startBBox.maxY + diffMaxY * factor
    };

    scene.applyBoundingBox(bbox);
  };

  frame();
}

function shuffle(inputArray) {
  var outputArray = inputArray.slice();
  for (var i = 0; i < outputArray.length; i++) {
    var j = Math.floor(Math.random() * outputArray.length);
    var temp = outputArray[i];
    outputArray[i] = outputArray[j];
    outputArray[j] = temp;
  }

  return outputArray;
}

function defined(number) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(number);
}

/***/ }),

/***/ "svlg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makePragmaParser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetchGLSL_js__ = __webpack_require__("iw7m");



var pragmaInclude = '#include ';
var nullCode = { code: ''

  /**
   * Naively parses glsl code and tries to replace all `#pragma` statements
   * with empty string. Gives structured collection of pragma statements back
   * 
   * @param {String} code 
   */
};function makePragmaParser(code) {
  if (!code) return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    return resolve(nullCode);
  });

  var parsedLines = processLineByLine(code);
  if (parsedLines.pending.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(parsedLines.pending).then(function () {
      return parsedLines;
    }).catch(function (error) {
      return { error: { error: error } };
    });
  }

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    return resolve(parsedLines);
  });
}

function processLineByLine(code) {
  var pending = [];
  var lines = code.split('\n');
  var outputLines = [];
  var currentIndex = 0;
  lines.forEach(function (line, index) {
    currentIndex = index;
    if (line && line[0] === '#') {
      outputLines.push('');
      processPragma(line);
    } else {
      outputLines.push(line);
    }
  });

  return {
    getCode: getCode,
    pending: pending
  };

  function getCode() {
    return outputLines.join('\n');
  }

  function processPragma(line) {
    if (line.indexOf(pragmaInclude) === 0) {
      var include = line.substr(pragmaInclude.length);
      var insertIndex = currentIndex;
      pending.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fetchGLSL_js__["a" /* default */])(include).then(function (code) {
        outputLines[insertIndex] = code;
      }));
    }
  }
}

/***/ }),

/***/ "vhRe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BaseShaderNode__ = __webpack_require__("4KA4");







var PanzoomTransform = function (_BaseShaderNode) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PanzoomTransform, _BaseShaderNode);

  function PanzoomTransform(config) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PanzoomTransform);

    // decode is used when we move particle read from the texture
    // otherwise we write particle to texture and need to reverse transform
    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PanzoomTransform.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PanzoomTransform)).call(this));

    _this.decode = config && config.decode;
    _this.srcPosName = config && config.posName || 'pos';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PanzoomTransform, [{
    key: 'getDefines',
    value: function getDefines() {
      if (this.decode) {
        // TODO: Need to figure out how to not duplicate this.
        return '\n  uniform vec2 u_min;\n  uniform vec2 u_max;\n';
      }
    }
  }, {
    key: 'getMainBody',
    value: function getMainBody() {
      if (this.decode) {
        return '\n  // move particle position according to current transform\n  vec2 du = (u_max - u_min);\n  pos.x = ' + this.srcPosName + '.x * du.x + u_min.x;\n  pos.y = ' + this.srcPosName + '.y * du.y + u_min.y;\n';
      }
      return '\n  pos.x = (' + this.srcPosName + '.x - u_min.x)/du.x;\n  pos.y = (' + this.srcPosName + '.y - u_min.y)/du.y;\n';
    }
  }]);

  return PanzoomTransform;
}(__WEBPACK_IMPORTED_MODULE_5__BaseShaderNode__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PanzoomTransform);

/***/ })

},["YJWA"]);


// WEBPACK FOOTER //
// static/js/app.ee33bb1956d327992042.js